(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["distributor-locations"] && !Shopify.designMode) return;
  try {
    
  window.initMap = function() {
    var styledMapType = new google.maps.StyledMapType(
    [
    {
      "elementType": "geometry",
      "stylers": [
        {
          "color": "#d9dadd"
        }
      ]
    },
    {
      "elementType": "labels.icon",
      "stylers": [
        {
          "visibility": "off"
        }
      ]
    },
    {
      "elementType": "labels.text.fill",
      "stylers": [
        {
          "color": "#616161"
        }
      ]
    },
    {
      "elementType": "labels.text.stroke",
      "stylers": [
        {
          "color": "#f5f5f5"
        }
      ]
    },
    {
      "featureType": "administrative",
      "elementType": "geometry",
      "stylers": [
        {
          "visibility": "off"
        }
      ]
    },
    {
      "featureType": "administrative.land_parcel",
      "stylers": [
        {
          "visibility": "off"
        }
      ]
    },
    {
      "featureType": "administrative.land_parcel",
      "elementType": "labels.text.fill",
      "stylers": [
        {
          "color": "#bdbdbd"
        }
      ]
    },
    {
      "featureType": "administrative.neighborhood",
      "stylers": [
        {
          "visibility": "off"
        }
      ]
    },
    {
      "featureType": "poi",
      "stylers": [
        {
          "visibility": "off"
        }
      ]
    },
    {
      "featureType": "poi",
      "elementType": "geometry",
      "stylers": [
        {
          "color": "#eeeeee"
        }
      ]
    },
    {
      "featureType": "poi",
      "elementType": "labels.text",
      "stylers": [
        {
          "visibility": "off"
        }
      ]
    },
    {
      "featureType": "poi",
      "elementType": "labels.text.fill",
      "stylers": [
        {
          "color": "#757575"
        }
      ]
    },
    {
      "featureType": "poi.park",
      "elementType": "geometry",
      "stylers": [
        {
          "color": "#e5e5e5"
        }
      ]
    },
    {
      "featureType": "poi.park",
      "elementType": "labels.text.fill",
      "stylers": [
        {
          "color": "#9e9e9e"
        }
      ]
    },
    {
      "featureType": "road",
      "elementType": "geometry",
      "stylers": [
        {
          "color": "#ffffff"
        }
      ]
    },
    {
      "featureType": "road",
      "elementType": "labels",
      "stylers": [
        {
          "visibility": "off"
        }
      ]
    },
    {
      "featureType": "road",
      "elementType": "labels.icon",
      "stylers": [
        {
          "visibility": "off"
        }
      ]
    },
    {
      "featureType": "road.arterial",
      "stylers": [
        {
          "visibility": "off"
        }
      ]
    },
    {
      "featureType": "road.arterial",
      "elementType": "labels.text.fill",
      "stylers": [
        {
          "color": "#757575"
        }
      ]
    },
    {
      "featureType": "road.highway",
      "elementType": "geometry",
      "stylers": [
        {
          "color": "#c5c4c9"
        }
      ]
    },
    {
      "featureType": "road.highway",
      "elementType": "labels",
      "stylers": [
        {
          "visibility": "off"
        }
      ]
    },
    {
      "featureType": "road.highway",
      "elementType": "labels.text.fill",
      "stylers": [
        {
          "color": "#616161"
        }
      ]
    },
    {
      "featureType": "road.local",
      "stylers": [
        {
          "visibility": "off"
        }
      ]
    },
    {
      "featureType": "road.local",
      "elementType": "labels.text.fill",
      "stylers": [
        {
          "color": "#9e9e9e"
        }
      ]
    },
    {
      "featureType": "transit",
      "stylers": [
        {
          "visibility": "off"
        }
      ]
    },
    {
      "featureType": "transit.line",
      "elementType": "geometry",
      "stylers": [
        {
          "color": "#e5e5e5"
        }
      ]
    },
    {
      "featureType": "transit.station",
      "elementType": "geometry",
      "stylers": [
        {
          "color": "#eeeeee"
        }
      ]
    },
    {
      "featureType": "water",
      "elementType": "geometry",
      "stylers": [
        {
          "color": "#f3f2f4"
        }
      ]
    },
    {
      "featureType": "water",
      "elementType": "labels.text",
      "stylers": [
        {
          "visibility": "off"
        }
      ]
    },
    {
      "featureType": "water",
      "elementType": "labels.text.fill",
      "stylers": [
        {
          "color": "#9e9e9e"
        }
      ]
    }
  ],
    {name: 'Styled Map'});


    var map = new google.maps.Map(document.getElementById('map'), {
      zoom: zoom,
      center: {lat: centerLat, lng: centerLng},
      gestureHandling: 'greedy',
      mapTypeControlOptions: { mapTypeIds: [] }
    });

    map.mapTypes.set('styled_map', styledMapType);
    map.setMapTypeId('styled_map');


    $.each(distributorLocations, function(index, location) {

      let imgObj = new google.maps.MarkerImage(image, null, null, null, new google.maps.Size(35,35));

      let marker = new google.maps.Marker({
        position: {lat: location.lat, lng: location.lng},
        map: map,
        icon: imgObj,
        title: location.title
      });

      var contentString = '<div id="content"><h4>'+location.title+'</h4><p>'+location.body+'</p></div>';

      var infowindow = new google.maps.InfoWindow({
        content: contentString
      });

      marker.addListener('click', function() {
        infowindow.open(map, marker);
        console.log(index);
      });

    });
  }


  jQuery.ajax({
    url: 'https://maps.googleapis.com/maps/api/js?key=AIzaSyDVGfUEkakzrMeVpEbOjY-La56c7cZxpj0&callback=initMap',
    dataType: 'script',
    async: true
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-reviews"] && !Shopify.designMode) return;
  try {
    
  $(function(){
    let handle = $('#product-reviews').attr('data-handle');
    loadReviewsPage(1,'');

    $('#rating-filter').change(function(){
      loadReviewsPage(1, $(this).val());
    });


    function loadReviewsPage(page, filter) {
      $.get('https://dashboard.cadenshae.co.nz/reviews?handle='+handle+'&token=54321tdrgdgsdt43tw45hs5y45cgxnj4z&page='+page+'&filter='+filter,
        function(res) {
          console.log(res);
          let starsHtml = '<span class="star-rating">';
          for (let i=0; i<5;i++) {
            if (i > res.average_stars) {
              starsHtml +='&#9734;';
            } else {
              starsHtml +='&#9733;';
            }
          }
          starsHtml += '</span>';
          $('.avg-stars').html(starsHtml+' '+res.total+' Reviews');
          $('.top-star-rating').html(starsHtml+' ('+res.total+')');

          let reviewContainer = $('#reviews');
  		reviewContainer.empty();
          $.each(res.reviews, function(key,review) {
            let reviewHtml = '<div class="customer-review">';
            reviewHtml += '<div class="d-block"><span class="reviewer-name">'+review.reviewer_name +'</span> Verified Buyer <div class="float-right review-date">'+review.review_date_formatted+'</div></div>';

            reviewHtml += '<div class="d-block star-rating">';
            for (let i=0; i<5;i++) {
              if (i >= review.stars) {
                reviewHtml +='&#9734;';
              } else {
                reviewHtml +='&#9733;';
              }
            }
            reviewHtml += '</div>';
            reviewHtml += '<div class="review-title">'+review.title+'</div>';
            reviewHtml += '<div class="review-body my-3">'+review.body+'</div>';

            if (review.photos) {
              reviewHtml += '<div class="row">';
              $.each(review.photos.split(';'), function(key,photoUrl) {
                reviewHtml += '<div class="col col-4 col-md-2"><img src="'+photoUrl+'"></div>';
              });
              reviewHtml += '</div>';
            }

            reviewHtml += '</div><hr class="my-5">';

            reviewContainer.append(reviewHtml);
          });

          let paginationHtml = '<button type="button" data-page="'+(res.page>1 ? res.page-1 : res.page)+'" class="btn btn-link pagination-link">&lt;</button>';

          let paginationStart = res.page - 4;
          if (paginationStart + 9 > res.pages) {
            paginationStart = res.pages - 9;
          }
          if (paginationStart < 1) {
            paginationStart = 1;
          }

          for (let i=paginationStart; i<=res.pages && i < paginationStart +9; i++) {
            paginationHtml += '<button type="button" data-page="'+i+'" class="btn btn-link pagination-link '+(i==res.page ? 'font-weight-bold' : '')+'">'+i+'</button>';
          }

          paginationHtml += '<button type="button" data-page="'+(res.page+1)+'" class="btn btn-link pagination-link">&gt;</button>';


          $('#review-pagination').html(paginationHtml);

          $('.pagination-link').click(function(){
            loadReviewsPage($(this).attr('data-page'), $('#rating-filter').val());
          });

        }
      );
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quick-view"]) return;
  try {
    
  function updateAddToCartButtonQuickview() {
    let modal = $('#other-product-modal');
    if (modal.find("#band-size-other option:selected").attr('data-available') === 'true') {
      modal.find('.add-item-other').removeClass('d-none');
      modal.find('.notify-me-other').addClass('d-none');
      modal.find('.out-of-stock-other').addClass('d-none');
    } else {
      modal.find('.add-item-other').addClass('d-none');
      modal.find('.notify-me-other').removeClass('d-none');
      modal.find('.out-of-stock-other').removeClass('d-none');
    }
  }

  function updateAddToCartButtonQuickviewMob() {
    let modal = $('#other-product-modal');
    if (modal.find(".mobile-add-to-cart option:selected").attr('data-available') === 'true' || modal.find(".mobile-add-to-cart option:selected").val() === 'add') {
      modal.find('.add-item-other').removeClass('d-none');
      modal.find('.notify-me-other').addClass('d-none');
      modal.find('.out-of-stock-other').addClass('d-none');
    } else {
      modal.find('.add-item-other').addClass('d-none');
      modal.find('.notify-me-other').removeClass('d-none');
      modal.find('.out-of-stock-other').removeClass('d-none');
    }
  }

  function addThumbnailEventsQuickview(parent) {
    parent.find('.picker-thumbnails,.play-overlay').click(function(){
  	if ($(this).attr('data-is-video')) {
  	  parent.find('.main-image').addClass('d-none');
        $('#quickview-prod-vid').removeClass('d-none');
        $('#quickview-prod-vid video').trigger('play');
      } else {
  	  $('#quickview-prod-vid video').trigger('pause');
  	  $('#quickview-prod-vid').addClass('d-none');
  	  parent.find('.main-image').removeClass('d-none');
        parent.find('.main-image').html($(this).html());
        parent.find('.main-image').find('img').removeClass('p-1');
        parent.find('.main-image').find('img').removeClass('border');
        parent.find('.main-image').find('img').addClass('img-fluid');
      }
      parent.find('.picker-thumbnails').find('img').removeClass('border');
      $(this).parent().find('.thumb-image').addClass('border');
    });
  }

  function replaceProductQuickview(parent, product, variantId) {

    let carosel = parent.find('.carousel').find('.carousel-inner');
    $('#quickview-prod-vid').addClass('d-none');
    parent.find('.main-image').removeClass('d-none');

    carosel.empty();
    let caroselIndicators = parent.find('.carousel-indicators');
    caroselIndicators.empty();
    parent.find('.thumbnails').empty();
    let carouselIndicatorsHtml = '';
    let carouselCount = 0;
    $.each(product.images,function(key,image) {
      let thumbnailHtml = '<div class="pb-2 pr-2"><picture class="picker-thumbnails">';

      let sizeWidths = Object.keys(image.sizes).reverse();
      let sizes = Object.values(image.sizes).reverse();
      $.each(sizes,function(key,size) {
        if (key >= sizes.length-2) {
          return;
        }
        thumbnailHtml += '<source media="(min-width: '+sizeWidths[key+1]+'px)" srcset="'+size+'">';
      });
      thumbnailHtml += '<img class="img-fluid p-1 thumb-image '+(key == 0 ? 'border' : '')+'" src="'+image.sizes['105']+'" alt="'+image.alt+'">'+
        '</picture></div>';

      parent.find('.thumbnails').append(thumbnailHtml);

      let caroselHtml = '<div class="text-center carousel-item '+(key == 0 ? 'active' : '')+'">'+
                            '<picture>';
      $.each(sizes,function(key,size) {
        if (key >= sizes.length-2) {
          return;
        }
        caroselHtml += '<source media="(min-width: '+sizeWidths[key+1]+'px)" srcset="'+size+'">';
      });
      caroselHtml += '<img class="" src="'+image.sizes['105']+'" alt="'+image.alt+'">';
      caroselHtml += '</picture></div>';
      carosel.append(caroselHtml);

      carouselIndicatorsHtml += '<li data-target="#carouselQuickView" data-slide-to="'+carouselCount+'" '+(carouselCount == 0 ? 'class="active"' : '')+'></li>';
      carouselCount++;
    });


        if (product.video) {
    		carouselIndicatorsHtml += '<li data-target="#carouselQuickView" data-slide-to="'+carouselCount+'" '+((carouselCount == 0) ? 'class="active"' : '')+'></li>';

  		let thumbnailHtml = '<div class="pb-2 pr-2 position-relative"><picture class="picker-thumbnails" data-is-video="true">';
  		let image = product.images[0];
  		let sizeWidths = Object.keys(image.sizes).reverse();
          let sizes = Object.values(image.sizes).reverse();
          $.each(sizes,function(key,size) {
            if (key >= sizes.length-2) {
              return;
            }
            thumbnailHtml += '<source media="(min-width: '+sizeWidths[key+1]+'px)" srcset="'+size+'">';
          });
          thumbnailHtml += '<img class="img-fluid p-1 thumb-image" data-is-video="true" src="'+image.sizes['105']+'" alt="'+image.alt+'">'+
            '</picture><img class="play-overlay" data-is-video="true" src="https://cdn.shopify.com/s/files/1/0052/4848/3421/t/14/assets/play_button.png"></div>';

          parent.find('.thumbnails').append(thumbnailHtml);

  		$('#quickview-prod-vid').empty();
          let vidHtml = '<video playsinline="playsinline" loop="loop" class="img-fluid" preload="metadata" aria-label="'+product.video.alt+'" poster="">';
          $.each(product.video.formats, function(key,val){
            vidHtml += '<source src="'+val+'" type="'+key+'">';
          });
          vidHtml += '</video>';
          $('#quickview-prod-vid').html(vidHtml);


          let vidHtmlMob = '<video playsinline="playsinline" loop="loop" class="video-mob" preload="metadata" aria-label="'+product.video.alt+'" poster="">';
          $.each(product.video.formats, function(key,val){
            vidHtmlMob += '<source src="'+val+'" type="'+key+'">';
          });
          vidHtmlMob += '</video>';
          let caroselHtml = '<div class="text-center carousel-item">'+vidHtmlMob+'</div>';

          carosel.append(caroselHtml);
        }
        caroselIndicators.append(carouselIndicatorsHtml);




    parent.find('.main-image').empty();
    let mainImage = product.images[0];
    let mainImageHtml = '';
    let sizeWidths = Object.keys(mainImage.sizes).reverse();
    let sizes = Object.values(mainImage.sizes).reverse();
    $.each(sizes,function(key,size) {
      if (key >= sizes.length-2) {
        return;
      }
      mainImageHtml += '<source media="(min-width: '+sizeWidths[key+1]+'px)" srcset="'+size+'">';
    });
    mainImageHtml += '<img class="img-fluid" src="'+mainImage.sizes['105']+'" alt="'+mainImage.alt+'">';
    parent.find('.main-image').html(mainImageHtml);

    let colorNameText = parent.find('.colour-name').find('b');
    colorNameText.text(product.colour);

    parent.find('.colour-picker').removeClass('border');

    parent.find('.description').html('<hr>'+product.description);

    let priceElement = parent.find('.price');
    let priceContainer = parent.find('.price-stars');
    let currency = priceContainer.attr('data-currency');
    priceContainer.find('.discount').remove();
    $.each(product.tags,function(key,tag){
      if (tag.substring(0,12) == 'discount_'+currency) {
  	  let message = tag.replace('discount_'+currency,'');
  	  priceContainer.append('<span class="discount">'+message+'</span>');
  	}
    });

    priceElement.text(priceElement.attr('data-format').replace('0.00', (product.price/100).toFixed(2)));

    let bandSize = parent.find('.band-size');
    let selectedIndex = bandSize.prop('selectedIndex');

    bandSize.attr('data-image-url', mainImage.sizes['360']);
    bandSize.attr('data-price', product.price);
    bandSize.attr('data-product-title', product.title);
    bandSize.attr('data-handle', product.handle);
    bandSize.attr('data-product-id', product.id);
    bandSize.empty();

    let mobileAddCart = parent.find('.mobile-add-to-cart');
    mobileAddCart.attr('data-image-url', mainImage.sizes['360']);
    mobileAddCart.attr('data-price', product.price);
    mobileAddCart.attr('data-product-title', product.title);
    mobileAddCart.attr('data-handle', product.handle);
    mobileAddCart.attr('data-product-id', product.id);
    mobileAddCart.empty();
    mobileAddCart.append('<option value="add">Add to cart</option>');

    $.each(product.variants,function(key,variant) {
      let mobOptionHtml = '<option value="'+variant.id+'" data-available="'+(variant.available ? 'true' : 'false')+'">'+
                      variant.title + (variant.available ? '' : ' - Sold Out')+
                    '</option>';
      mobileAddCart.append(mobOptionHtml);

  	let optionHtml = '';
      if (!variantId) {
        optionHtml = '<option '+(key == selectedIndex ? 'selected="selected"' : '')+' value="'+variant.id+'" data-available="'+(variant.available ? 'true' : 'false')+'">'+
                          variant.title + (variant.available ? '' : ' - Sold Out')+
                        '</option>';
  	} else {
  	  optionHtml = '<option '+(variantId == variant.id ? 'selected="selected"' : '')+' value="'+variant.id+'" data-available="'+(variant.available ? 'true' : 'false')+'">'+
                          variant.title + (variant.available ? '' : ' - Sold Out')+
                        '</option>';
  	}
      bandSize.append(optionHtml);

    });

    addThumbnailEventsQuickview(parent);
  }


  $(document).ready(function() {
    let quickViewModal = $('#other-product-modal');

    quickViewModal.find("#band-size-other").change(function(){
      updateAddToCartButtonQuickview();
    });
    quickViewModal.find(".mobile-add-to-cart").change(function(){
      updateAddToCartButtonQuickviewMob();
    });

    quickViewModal.on('show.bs.modal', function (event) {
      let button = $(event.relatedTarget); // Button that triggered the modal
      let handle = button.data('handle');
      let variantId = button.data('varaint-id');

      if (handle === undefined) {
        handle = $(this).attr('data-handle');
      }
      let modal = $(this);

      allProductsLoader(function(allProducts) {

        if (!allProducts[handle]) {
          window.location = '/products/'+handle;
          return;
        }

        let product = allProducts[handle];


        replaceProductQuickview(modal, product, variantId);
        updateAddToCartButtonQuickview();

        modal.find('#main-title-other').text(product.title.replace(product.colour,''));
        modal.find('.view-details').attr('href','/products/'+product.handle);

        let circleContainer = $('#other-product-modal').find('.alternate-colours').find('.colour-circles');
        circleContainer.empty();
        $.each(product.colour_group,function(key,handle) {
          if (allProducts[handle] && allProducts[handle].online) {
            let colourCircleHtml = '<a href="/products/'+handle+'" data-handle="'+handle+'" class="colour-picker colour-picker-modal rounded-circle mr-2 '+(handle == product.handle ? 'border' : '' )+'">';
            colourCircleHtml += '<img class="rounded-circle" src="'+allProducts[handle].swatch+'" alt="Alternate colour">';
            colourCircleHtml += '</a>';
            circleContainer.append(colourCircleHtml);
          }
        });
        $('.colour-picker-modal').click(function(e) {
          e.preventDefault();
          changeColourQuickview(modal, $(this).attr('data-handle'));
          $(this).addClass('border');

        });

      });

    });

  });

  function changeColourQuickview(modal, handle) {
    modal.find('.modal-body').height($('#other-product-modal').find('.modal-body').height());
    allProductsLoader(function(allProducts) {
      let product = allProducts[handle];

      replaceProductQuickview(modal, product);
      updateAddToCartButtonQuickview();
    });
    modal.find('.view-details').attr('href','/products/'+handle);
    setTimeout(function() {
      modal.find('.modal-body').height('');
    },2000);
  }



  $(function () {

    let modal = $('#other-product-modal');

    modal.find('.add-item-other').click(function(e){
      let dropdown = $('#other-product-modal').find("#band-size-other");
      let selectedOption = $('#other-product-modal').find("#band-size-other option:selected");
      if (selectedOption.attr('data-available') === 'true') {
        addToSideCart(selectedOption.val(),dropdown.attr('data-price'),dropdown.attr('data-image-url'),dropdown.attr('data-product-title'),selectedOption.html(),dropdown.attr('data-handle'));
        modal.modal('hide');
        showSideCart();
      }
    });

    modal.find('.mobile-add-to-cart').on('change', function() {
      if (this.value !== 'add') {
        let dropdown = $(this);
        let selectedOption = dropdown.find('option:selected');
        if (selectedOption.attr('data-available') === 'true') {
          addToSideCart(selectedOption.val(),dropdown.attr('data-price'),dropdown.attr('data-image-url'),dropdown.attr('data-product-title'),selectedOption.html(),dropdown.attr('data-handle'));
          modal.modal('hide');
          showSideCart();
        }
      }
    });

    modal.find(".current-colour").click(function(e) {
      e.preventDefault();
      modal.find(".alternate-colours").toggleClass('no-show');
    });

    modal.find('.notify-me-other').click(function() {

      modal.find('.success-other').removeClass('d-none');

      setTimeout(function(){
        modal.find('.success-other').addClass('d-none');
      },5000);
      let klavyoKey = $('#other-product-modal').attr('data-klaviyo-key');
      let variant_id = ($('.mobile-add-to-cart').val() === 'add' ? $("#band-size-other option:selected").val() : $('.mobile-add-to-cart').val());
      let product_id = ($('.mobile-add-to-cart').val() === 'add' ? $("#band-size-other").attr('data-product-id') : $('.mobile-add-to-cart').attr('data-product-id'));
      let formData = {'a': klavyoKey,'email': $('#modal-notify-email').val(),
        'variant': variant_id, 'g': '',
        'product': product_id,'platform': 'shopify',
        'subscribe_for_newsletter' : false};
      $.post('https://a.klaviyo.com/onsite/components/back-in-stock/subscribe',$.param(formData));

      //let formData = {'variant_id': $("#band-size-other option:selected").val(), 'destination': $('#modal-notify-email').val(),'alertType': 'email', 'domain': $('#size-modal').attr('data-store-url')};
      //$.post('https://outofstock.eastsideco.io/api/create-alert',$.param(formData));
    });

  });

  $('#carouselQuickView').on('slide.bs.carousel', function (event) {
    let vid = $(event.relatedTarget).find('video');
    if (vid.hasClass('video-mob')) {
      vid.trigger('play');
    } else {
      $('.video-mob').trigger('pause');
    }

  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["relove"]) return;
  try {
    
   $('#relove-form').submit(function(e){
  e.preventDefault();
  let form = $(this)

  $.post('https://dashboard.cadenshae.co.nz/relove',$(this).serialize(),function(res){
  	form.hide();

  	$('#relove-number').text(res);
  	$('#success-view').removeClass('d-none');
  });

   });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rep-locations"] && !Shopify.designMode) return;
  try {
    
  window.initMap = function() {
    var styledMapType = new google.maps.StyledMapType(
    [
    {
      "elementType": "geometry",
      "stylers": [
        {
          "color": "#d9dadd"
        }
      ]
    },
    {
      "elementType": "labels.icon",
      "stylers": [
        {
          "visibility": "off"
        }
      ]
    },
    {
      "elementType": "labels.text.fill",
      "stylers": [
        {
          "color": "#616161"
        }
      ]
    },
    {
      "elementType": "labels.text.stroke",
      "stylers": [
        {
          "color": "#f5f5f5"
        }
      ]
    },
    {
      "featureType": "administrative",
      "elementType": "geometry",
      "stylers": [
        {
          "visibility": "off"
        }
      ]
    },
    {
      "featureType": "administrative.land_parcel",
      "stylers": [
        {
          "visibility": "off"
        }
      ]
    },
    {
      "featureType": "administrative.land_parcel",
      "elementType": "labels.text.fill",
      "stylers": [
        {
          "color": "#bdbdbd"
        }
      ]
    },
    {
      "featureType": "administrative.neighborhood",
      "stylers": [
        {
          "visibility": "off"
        }
      ]
    },
    {
      "featureType": "poi",
      "stylers": [
        {
          "visibility": "off"
        }
      ]
    },
    {
      "featureType": "poi",
      "elementType": "geometry",
      "stylers": [
        {
          "color": "#eeeeee"
        }
      ]
    },
    {
      "featureType": "poi",
      "elementType": "labels.text",
      "stylers": [
        {
          "visibility": "off"
        }
      ]
    },
    {
      "featureType": "poi",
      "elementType": "labels.text.fill",
      "stylers": [
        {
          "color": "#757575"
        }
      ]
    },
    {
      "featureType": "poi.park",
      "elementType": "geometry",
      "stylers": [
        {
          "color": "#e5e5e5"
        }
      ]
    },
    {
      "featureType": "poi.park",
      "elementType": "labels.text.fill",
      "stylers": [
        {
          "color": "#9e9e9e"
        }
      ]
    },
    {
      "featureType": "road",
      "elementType": "geometry",
      "stylers": [
        {
          "color": "#ffffff"
        }
      ]
    },
    {
      "featureType": "road",
      "elementType": "labels",
      "stylers": [
        {
          "visibility": "off"
        }
      ]
    },
    {
      "featureType": "road",
      "elementType": "labels.icon",
      "stylers": [
        {
          "visibility": "off"
        }
      ]
    },
    {
      "featureType": "road.arterial",
      "stylers": [
        {
          "visibility": "off"
        }
      ]
    },
    {
      "featureType": "road.arterial",
      "elementType": "labels.text.fill",
      "stylers": [
        {
          "color": "#757575"
        }
      ]
    },
    {
      "featureType": "road.highway",
      "elementType": "geometry",
      "stylers": [
        {
          "color": "#c5c4c9"
        }
      ]
    },
    {
      "featureType": "road.highway",
      "elementType": "labels",
      "stylers": [
        {
          "visibility": "off"
        }
      ]
    },
    {
      "featureType": "road.highway",
      "elementType": "labels.text.fill",
      "stylers": [
        {
          "color": "#616161"
        }
      ]
    },
    {
      "featureType": "road.local",
      "stylers": [
        {
          "visibility": "off"
        }
      ]
    },
    {
      "featureType": "road.local",
      "elementType": "labels.text.fill",
      "stylers": [
        {
          "color": "#9e9e9e"
        }
      ]
    },
    {
      "featureType": "transit",
      "stylers": [
        {
          "visibility": "off"
        }
      ]
    },
    {
      "featureType": "transit.line",
      "elementType": "geometry",
      "stylers": [
        {
          "color": "#e5e5e5"
        }
      ]
    },
    {
      "featureType": "transit.station",
      "elementType": "geometry",
      "stylers": [
        {
          "color": "#eeeeee"
        }
      ]
    },
    {
      "featureType": "water",
      "elementType": "geometry",
      "stylers": [
        {
          "color": "#f3f2f4"
        }
      ]
    },
    {
      "featureType": "water",
      "elementType": "labels.text",
      "stylers": [
        {
          "visibility": "off"
        }
      ]
    },
    {
      "featureType": "water",
      "elementType": "labels.text.fill",
      "stylers": [
        {
          "color": "#9e9e9e"
        }
      ]
    }
  ],
    {name: 'Styled Map'});


    var map = new google.maps.Map(document.getElementById('map'), {
      zoom: zoom,
      center: {lat: centerLat, lng: centerLng},
      gestureHandling: 'greedy',
      mapTypeControlOptions: { mapTypeIds: [] }
    });

    map.mapTypes.set('styled_map', styledMapType);
    map.setMapTypeId('styled_map');


    $.each(distributorLocations, function(index, location) {

      let imgObj = new google.maps.MarkerImage(image, null, null, null, new google.maps.Size(35,35));

      let marker = new google.maps.Marker({
        position: {lat: location.lat, lng: location.lng},
        map: map,
        icon: imgObj,
        title: location.title
      });

      var contentString = '<div id="content"><h4>'+location.title+'</h4><p>'+location.body+'</p></div>';

      var infowindow = new google.maps.InfoWindow({
        content: contentString
      });

      marker.addListener('click', function() {
        infowindow.open(map, marker);
        console.log(index);
      });

    });
  }


  jQuery.ajax({
    url: 'https://maps.googleapis.com/maps/api/js?key=AIzaSyDVGfUEkakzrMeVpEbOjY-La56c7cZxpj0&callback=initMap',
    dataType: 'script',
    async: true
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["returns-cool"]) return;
  try {
    

$(function() {
    let extraDiscount = $('.returns-cool').attr('data-exchange-bonus');
	let priceFormat = $('.returns-cool').attr('data-price-format');
    let allProducts = [];
    let allProductsWithStock = {};
    allProductsLoader(function(allProds) {
      //debugger
		allProducts = allProds;
        console.log(allProds,'products');
        $.each(allProds, function(key,product){
          for (const variant of product.variants) {
            if (variant.available) {
              allProductsWithStock[key] = product;
              break;
            }
          }
        });
        console.log(allProductsWithStock);
    });


    $('#find-order').click(function () {
        let orderNumber = $('#order_number').val();
        let orderEmail = $('#order_email').val();
		let countryCode = $('#country_code').val();
		$('#final_info').html($('#final_info').html().replace('*****',orderNumber.substring(2))); // for the AU site
        $.ajax({
            url:'https://dashboard.cadenshae.co.nz/customerrefundorder?country='+countryCode+'&order_number='+orderNumber+'&email='+orderEmail,
            method:'GET',
			statusCode: {
              404: function() {
                $('.alert-warning').removeClass('d-none');
              }
  			}
        }).done(function (res) {
			if (res.message) {
			  $('.alert-warning').html(res.message);
			  $('.alert-warning').removeClass('d-none');
			  return;
			}

			$('#order_details').html('<h2 class="text-center">Select an item to return</h2>');

            $.each(res.order_items,function(key,item) {
				$.each(allProducts,function(pkey, product){
					$.each(product.variants,function(ikey,variant){
						if (variant.id === item.variant_id) {
							item.product = product;
							item.variant = variant;
						}
					});
				});

				if (item.product) {
				  let image = item.product.images[0];
				  let thumbnailHtml = getImageHtml(image);

				  for (i=0;i<item.qty;i++) {
                    let itemHtml = `<div><div class="row mt-4 p-2 order-item `+(item.product.non_returnable ? ``:`returnable-item`)+`" data-variant-id="`+key+`" data-count="`+i+`">
									<div class="col col-12 col-md-2 px-0 thumbnail-container">`+thumbnailHtml+`</div>
									<div class="col px-0 px-md-4 mt-3 select-item-info">
                                      <h3>`+item.product.title+`</h3>
                                      <span>Size: `+item.variant.title+` | Quantity: `+item.qty+`</span>
                                      <span class="d-block select-item-price">`+priceFormat.replace('0.00',item.price)+`</span>
                                      `+(item.product.non_returnable ? `<span class="d-block non-returnable">This item is non-returnable.</span>`:``)+`
									</div>
								</div></div>`;
                    $('#order_details').append(itemHtml);
				  }
				}
            });

		    $('#order_details').append('<div class="w-100 text-right mt-2"><button class="btn btn-primary d-none continue-btn">Continue</button></div>');
			$('#find-order-form').addClass('d-none');

			$('.continue-btn').click(function(){
                $('#order_details').addClass('d-none');
				window.scrollTo(0, 0);
                $('#return_notes').removeClass('d-none');
            });

			$('.returnable-item').click(function(){
				window.scrollTo(0, 0);
				loadExchangeView1(res, $(this).attr('data-variant-id'), $(this).attr('data-count'));
			});

        });
    });

    function loadExchangeView1(order, selectedVariant,productCount) {
		$('#order_details').addClass('d-none');
		$('#item_exchange').removeClass('d-none');

		let selectedProd = order.order_items[selectedVariant];
		let itemProduct = selectedProd.product;
		let itemVariant = selectedProd.variant;
		let item = selectedProd;
		let altColoursHtml = '';
		let altColourCount = 0;
		$.each(selectedProd.product.colour_group,function(key,handle){
			if (altColourCount >= 3) {
			  return;
			}
			if (allProductsWithStock[handle]) {
			  let altImg = allProducts[handle].images[0];
			  altColoursHtml += '<div class="col-4 col-md-3 px-1 px-md-2 '+(altColourCount==2 ? 'd-none' : '')+' d-md-block">'+getImageHtml(altImg)+'</div>';
			  altColourCount++;
			}
		});

		let altProducts = getSimilarPricedProducts(item.price,itemProduct,false,item.refundable);
		let altProductsHtml = '';
		let altProdCount = 0;
		$.each(altProducts,function(key,prod){
			let altImg = prod.images[0];
			altProductsHtml += '<div class="col-4 col-md-3 px-1 px-md-2 '+(altProdCount==2 ? 'd-none' : '')+' d-md-block">'+getImageHtml(altImg)+'</div>';
			altProdCount++;
		});

		let image = itemProduct.images[0];
		let thumbnailHtml = getImageHtml(image);

        let itemHtml = `<h2 class="text-center mb-0">`+itemProduct.title+`</h2>
        			<button class="btn btn-back d-none d-md-block item_exchange_back_btn">←</button>
					<div class="row exchange-item">
					  <div class="col col-5 d-none d-md-block">
                        `+thumbnailHtml+`
					  </div>`+
					  // <div class="col text-center text-md-left mt-2">
       //                  <span class="select-item-size">Size: `+item.variant.title+` | Quantity: `+item.qty+`</span>
       //                  <span class="d-block select-item-price">`+priceFormat.replace('0.00',item.price)+`</span>
       //                  <div class="w-100 text-left"><button class="btn btn-back d-md-none item_exchange_back_btn py-0">←</button></div>
       //                  <div class="border m-1 p-2 text-left" id="exchange-colour">
       //                      <h3 class="text-left px-1">Exchange for a new size or colour</h3>
       //                      <div class="row mx-0">
       //                          `+altColoursHtml+`
       //                          <div class="col-4 col-md-3 px-1 px-md-2">
       //                              <div class="view-more-box">
       //                                  <div>
       //                                      <span class="d-block text-center plus">+</span>
       //                                      <span class="d-block text-center vtext">View all colours</span>
       //                                  </div>
       //                              </div>
       //                          </div>
       //                      </div>
       //                  </div>
       //                  <div class="border m-1 p-2 text-left" id="exchange-other">
       //                      <h3 class="text-left px-1">Exchange for different product</h3>
       //                      <div class="row mx-0">
       //                          `+altProductsHtml+`
       //                          <div class="col-4 col-md-3 px-1 px-md-2">
       //                              <div class="view-more-box">
       //                                  <div>
       //                                      <span class="d-block text-center plus">+</span>
       //                                      <span class="d-block text-center vtext">View more products</span>
       //                                  </div>
       //                              </div>
       //                          </div>
       //                      </div>
       //                  </div>
                      `
                      <div class="col">
                        <div>To return this item you will be asked a few questions to help ensure we're able to process your return correctly.</div>
                        <div class="m-1">
                          <button class="btn btn-secondary" id="refund-item">Continue with return</button>
                        </div>
                      </div>
					</div>
				</div>`;
		$('#item_exchange').html(itemHtml);

		$('.item_exchange_back_btn').click(function(){
			$('#item_exchange').addClass('d-none');
			$('#order_details').removeClass('d-none');
		});

		$('#exchange-colour').click(function(){
			window.scrollTo(0, 0);
			loadExchangeColourView(order, selectedVariant,productCount);
		});
		$('#exchange-other').click(function(){
			window.scrollTo(0, 0);
			loadExchangeOtherView(order, selectedVariant,productCount);
		});

		$('#refund-item').click(function(){
			window.scrollTo(0, 0);
			loadReturnQuestion1View(order, selectedVariant,productCount);
		});

	}

	function loadExchangeColourView(order, selectedVariant,productCount) {
		$('#item_exchange').addClass('d-none');
		$('#item_exchange_colour').removeClass('d-none');
		let selectedProd = order.order_items[selectedVariant];
		let itemProduct = selectedProd.product;
		let itemVariant = selectedProd.variant;
		let item = selectedProd;

		let altColoursHtml = '';
		$.each(selectedProd.product.colour_group,function(key,handle){
			if (allProductsWithStock[handle]) {
			  let altImg = allProducts[handle].images[0];
			  altColoursHtml += '<div class="col-4 col-md-3"><div class="pick-colour" data-handle="'+handle+'">'+getImageHtml(altImg)+'</div></div>';
			}
		});
		let sizeHtml = '';
		if (allProductsWithStock[selectedProd.product.colour_group[0]]) {
		$.each(allProducts[selectedProd.product.colour_group[0]].variants,function(key,variant){
			if (variant.available) {
				sizeHtml += '<div class="col col-3 mb-3"><button class="btn btn-secondary pick-size w-100" data-handle="'+allProducts[selectedProd.product.colour_group[0]].handle+'" data-variant-id="'+variant.id+'">'+variant.title+'</button></div>';
			} else {
				sizeHtml += '<div class="col col-3 mb-3">'+variant.title+' - Out of stock</div>';
			}
		});
		}


		let image = itemProduct.images[0];
		let thumbnailHtml = getImageHtml(image);

		let itemHtml = `<h2 class="text-center mb-0">`+itemProduct.title+`</h2>
						<button class="btn btn-back d-none d-md-block colour_exchange_back_btn">←</button>
						<div class="row exchange-item">
							<div class="col col-5 d-none d-md-block">
                              `+thumbnailHtml+`
					        </div>
					  <div class="col text-center text-md-left mt-2">
                        <span class="select-item-size">Size: `+item.variant.title+` | Quantity: `+item.qty+`</span>
                        <span class="d-block select-item-price">`+priceFormat.replace('0.00',item.price)+`</span>
                        <div class="w-100 text-left"><button class="btn btn-back d-md-none colour_exchange_back_btn py-0">←</button></div>

                              <div class="border m-1 p-3">
                                <h3 class="text-left">Select colour</h3>
                                <div class="row">
                                  `+altColoursHtml+`
                                </div>
                              </div>
                              <div class="border m-1 p-3">
                                <h3 class="mb-0">Select size</h3>
                                <a class="mb-3 d-block unsure-guide" href="/pages/size-guides">Unsure? Check out our <span>size guides.</span></a>
                                <div class="row exchange-sizes">
                                  `+sizeHtml+`
                                </div>
                              </div>
                              <div class="row m-1 justify-content-end">
							    <button class="btn btn-primary" id="btn_colour_next" disabled>Next</button>
							  </div>
							</div>
						</div>`;
		$('#item_exchange_colour').html(itemHtml);

		$('.pick-colour').first().addClass('selected');

		$('.colour_exchange_back_btn').click(function(){
			$('#item_exchange_colour').addClass('d-none');
			$('#item_exchange').removeClass('d-none');
		});

		$('.pick-colour').click(function(){
			$('.pick-colour').removeClass('selected');
			$(this).addClass('selected');
			$('#btn_colour_next').prop('disabled',true);
			let sizeHtml = '';
			let selectedHandle = $(this).attr('data-handle');
			$.each(allProducts[selectedHandle].variants,function(key,variant){
				if (variant.available) {
					sizeHtml += '<div class="col col-3 mb-3"><button class="btn btn-secondary pick-size w-100" data-handle="'+selectedHandle+'" data-variant-id="'+variant.id+'">'+variant.title+'</button></div>';
				} else {
					sizeHtml += '<div class="col col-3 mb-3">'+variant.title+' - Out of stock</div>';
				}
			});
			$('.exchange-sizes').html(sizeHtml);

			$('.pick-size').click(function(){
				$('.pick-size').removeClass('selected');
				$(this).addClass('selected');
				if ($('.pick-colour.selected').length) {
					$('#btn_colour_next').prop('disabled',false);
				}
			});
		});

		$('.pick-size').click(function(){
			$('.pick-size').removeClass('selected');
			$(this).addClass('selected');
			if ($('.pick-colour.selected').length) {
				$('#btn_colour_next').prop('disabled',false);
			}
		});

		$('#btn_colour_next').click(function(){
			let selectedVariantId = $('.pick-size.selected').attr('data-variant-id');
			$('.order-item').each(function(){
				if ($(this).attr('data-variant-id') == selectedVariant && $(this).attr('data-count') == productCount) {
					let selectedExchangeProd = allProducts[$('.pick-size.selected').attr('data-handle')];
					let exchangeVariant = {};
					$.each(selectedExchangeProd.variants,function(key, variant){
						if (variant.id == selectedVariantId) {
							exchangeVariant = variant;
						}
					});

					let image = selectedExchangeProd.images[0];
					let thumbnailHtml = getImageHtml(image);


					$(this).parent().find('.exchange-selected').remove();
					$(this).find('.exchange-note').remove();

					$(this).find('.select-item-info').prepend(`<span class="exchange-note d-block mb-2">Item you're sending back</span>`);

					$(this).parent().append(`
					<div class="row mt-0 p-2 order-item exchange-selected" data-from="`+itemVariant.id+`" data-to="`+selectedVariantId+`">
									<div class="col col-12 col-md-2 px-0 thumbnail-container">`+thumbnailHtml+`</div>
									<div class="col px-0 px-md-4 mt-3 select-item-info">
                                      <span class="exchange-note d-block mb-2">Item you're exchanging for</span>
                                      <h3>`+selectedExchangeProd.title+`</h3>
                                      <span>Size: `+exchangeVariant.title+` | Quantity: 1</span>
                                      <button class="remove-selection btn btn-link d-block pl-0">Remove Item</button>
									</div>
								</div>
				    `);
				  $('.exchange-selected').click(function(e){
					e.stopImmediatePropagation();
    			  });
				  $('.remove-selection').click(function(e){
					e.stopImmediatePropagation();
					let itemContainer = $(this).parents('.exchange-selected');
					itemContainer.parent().find('.exchange-note').remove();
       				itemContainer.remove();
					checkContinueValid();
    			  });
				  $('.continue-btn').removeClass('d-none');
				}
			});
			$('#item_exchange_colour').addClass('d-none');
			window.scrollTo(0, 0);
			$('#order_details').removeClass('d-none');
		});

	}

	function checkContinueValid() {
		if(!$('.exchange-selected').length) {
			$('.continue-btn').addClass('d-none');
		}
	}


	function loadExchangeOtherView(order, selectedVariant, productCount) {
		$('#item_exchange').addClass('d-none');
		$('#item_exchange_colour').removeClass('d-none');
		let selectedProd = order.order_items[selectedVariant];
		let itemProduct = selectedProd.product;
		let itemVariant = selectedProd.variant;
		let item = selectedProd;

		let altProducts = getSimilarPricedProducts(item.price,itemProduct,true,item.refundable);
		let altProductsHtml = '';
		$.each(altProducts,function(key,prod){
			let altImg = prod.images[0];
			let variantHtml = '<select class="other-size-select py-2" data-handle="'+prod.handle+'">';
			variantHtml += '<option value="exchange">Select size</option>';

			$.each(prod.variants,function(key,variant){
				variantHtml += '<option value="'+variant.id+'" '+(variant.available ? '' : 'disabled')+'>'+
                    variant.title + (variant.available ? '' : ' - Sold Out')+
                  '</option>';
			});
			variantHtml += '</select>';
			altProductsHtml += '<div class="col-12 col-md-6 mb-4">'+getImageHtml(altImg)+'<div class="text-center">'+prod.title+'</div><div>'+variantHtml+'</div></div>';
		});

		let image = itemProduct.images[0];
		let thumbnailHtml = getImageHtml(image);

		let itemHtml = `<h2 class="text-center mb-0">`+itemProduct.title+`</h2>
						<button class="btn btn-back d-none d-md-block other_exchange_back_btn">←</button>
						<div class="row exchange-item">
							<div class="col col-5 d-none d-md-block">
                              `+thumbnailHtml+`
					        </div>
					  <div class="col text-center text-md-left mt-2">
                        <span class="select-item-size">Size: `+item.variant.title+` | Quantity: `+item.qty+`</span>
                        <span class="d-block select-item-price">`+priceFormat.replace('0.00',item.price)+`</span>
                        <div class="w-100 text-left"><button class="btn btn-back d-md-none other_exchange_back_btn py-0">←</button></div>

                              <div class="border m-1 p-3">
                                <h3 class="text-left">Select product</h3>
                                <div class="row">
                                  `+altProductsHtml+`
                                </div>

                                <h3 class="text-left"><b>Want something else?</b></h3>
                                <p class="text-left">If you want to exchange for a product that isn't on this list please let us know below:</p>
                                <textarea class="form-control" id="other-exchange-info" rows="3"></textarea>
                                <button class="btn btn-primary mt-2" id="other-exchange">Continue</button>
                              </div>
							</div>
						</div>`;
		$('#item_exchange_colour').html(itemHtml);

		$('#other-exchange').click(function(){
		  $('.order-item').each(function(){
			if ($(this).attr('data-variant-id') == selectedVariant && $(this).attr('data-count') == productCount) {
			  $(this).parent().find('.exchange-selected').remove();
			  $(this).parent().append(`<div class="row mt-0 p-2 order-item exchange-selected" data-from="`+itemVariant.id+`" data-to="custom-exchange" data-reason-notes="`+encodeURIComponent($('#other-exchange-info').val())+`">
									<div class="col col-12 col-md-2 px-0 thumbnail-container"></div>
									<div class="col px-0 px-md-4 mt-3 select-item-info">
                                      <span class="exchange-note d-block mb-2">Custom exchange info:</span>

                                      <p>`+$('#other-exchange-info').val()+`</p>
                                      <button class="remove-selection btn btn-link d-block pl-0">Remove Item</button>
									</div>
								</div>`);

				  $('.remove-selection').click(function(e){
					e.stopImmediatePropagation();
       				let itemContainer = $(this).parents('.exchange-selected');
					itemContainer.parent().find('.exchange-note').remove();
       				itemContainer.remove();
					checkContinueValid();
    			  });
				  $('.continue-btn').removeClass('d-none');
			}
		  });
		  $('#item_exchange_colour').addClass('d-none');
		  $('#order_details').removeClass('d-none');
		  window.scrollTo(0, 0);
		});

		$('.other_exchange_back_btn').click(function(){
			$('#item_exchange_colour').addClass('d-none');
			$('#item_exchange').removeClass('d-none');
		});

		$('.other-size-select').change(function(){
			let selectedVariantId = $(this).children("option:selected").val();
			let selectedHandle = $(this).attr('data-handle');
			$('.order-item').each(function(){
				if ($(this).attr('data-variant-id') == selectedVariant && $(this).attr('data-count') == productCount) {
					let selectedExchangeProd = allProducts[selectedHandle];
					let exchangeVariant = {};
					$.each(selectedExchangeProd.variants,function(key, variant){
						if (variant.id == selectedVariantId) {
							exchangeVariant = variant;
						}
					});

					let image = selectedExchangeProd.images[0];
					let thumbnailHtml = getImageHtml(image);

					$(this).parent().find('.exchange-selected').remove();
					$(this).find('.exchange-note').remove();

					$(this).find('.select-item-info').prepend(`<span class="exchange-note d-block mb-2">Item you're sending back</span>`);

					$(this).parent().append(`
					<div class="row mt-0 p-2 order-item exchange-selected" data-from="`+itemVariant.id+`" data-to="`+selectedVariantId+`">
									<div class="col col-12 col-md-2 px-0 thumbnail-container">`+thumbnailHtml+`</div>
									<div class="col px-0 px-md-4 mt-3 select-item-info">
                                      <span class="exchange-note d-block mb-2">Item you're exchanging for</span>
                                      <h3>`+selectedExchangeProd.title+`</h3>
                                      <span>Size: `+exchangeVariant.title+` | Quantity: 1</span>
                                      <button class="remove-selection btn btn-link d-block pl-0">Remove Item</button>
									</div>
								</div>
				    `);


				  $('.exchange-selected').click(function(e){
					e.stopImmediatePropagation();
    			  });
				  $('.remove-selection').click(function(e){
					e.stopImmediatePropagation();
       				let itemContainer = $(this).parents('.exchange-selected');
					itemContainer.parent().find('.exchange-note').remove();
       				itemContainer.remove();
					checkContinueValid();
    			  });
				  $('.continue-btn').removeClass('d-none');
				}
			});
			$('#item_exchange_colour').addClass('d-none');
			$('#order_details').removeClass('d-none');
			window.scrollTo(0, 0);
		});

	}

	function loadReturnQuestion1View(order, selectedVariant, productCount) {
		$('#item_exchange').addClass('d-none');
		$('#item_return_questions1').removeClass('d-none');
		let selectedProd = order.order_items[selectedVariant];
		let itemProduct = selectedProd.product;
		let itemVariant = selectedProd.variant;
		let item = selectedProd;

		let image = itemProduct.images[0];
		let thumbnailHtml = getImageHtml(image);

		let reasonsHtml = '';
		$.each(returnReasons, function (key, reason) {
			reasonsHtml += `<div class="form-group form-check col-md-4">
                              <input name='reason[]' value="`+reason+`" type="checkbox" class="form-check-input return-reason" id="reason`+key+`">
                              <label class="form-check-label" for="reason`+key+`">`+reason+`</label>
                            </div>`;
		});


		let questionsHtml = `<h2 class="text-center mb-0">`+itemProduct.title+`</h2>
						<button class="btn btn-back d-none d-md-block return_question1_back_btn">←</button>
						<div class="row exchange-item">
							<div class="col col-5 d-none d-md-block">
                        `+thumbnailHtml+`
					  </div>
					  <div class="col text-center text-md-left mt-2">
                        <span class="select-item-size">Size: `+item.variant.title+` | Quantity: `+item.qty+`</span>
                        <span class="d-block select-item-price">`+priceFormat.replace('0.00',item.price)+`</span>
                        <div class="w-100 text-left"><button class="btn btn-back d-md-none return_question1_back_btn py-0">←</button></div>


                              <div class="border m-1 p-3 text-left">
                                <h3>Why are you returning this item?</h3>
                                <div class="row mx-1">
                                  `+reasonsHtml+`
                                </div>

                                <div class="form-group">
                                    <label for="pleaseDescribeTextarea">Please describe</label>
                                    <textarea class="form-control" id="pleaseDescribeTextarea" rows="3"></textarea>
                                </div>

                              </div>
                        	  <div class="row m-1 justify-content-end">
                                <button class="btn btn-primary q1-button">Next</button>
                              </div>
						</div>`;
		$('#item_return_questions1').html(questionsHtml);

		$('.return_question1_back_btn').click(function(){
			$('#item_return_questions1').addClass('d-none');
            $('#item_exchange').removeClass('d-none');
		});

		$('.q1-button').click(function(){
            let reasons = [];
            $('.return-reason:checked').each(function(){
               reasons.push($(this).val());
            });
            window.scrollTo(0, 0);
			loadReturnQuestion2View(order, selectedVariant, reasons.join(','),$('#pleaseDescribeTextarea').val(), productCount);
		});
	}



	function loadReturnQuestion2View(order, selectedVariant,returnReason,reasonNotes, productCount) {
		$('#item_return_questions1').addClass('d-none');
		$('#item_return_questions2').removeClass('d-none');
		let selectedProd = order.order_items[selectedVariant];
		let itemProduct = selectedProd.product;
		let itemVariant = selectedProd.variant;
		let item = selectedProd;

		let image = itemProduct.images[0];
		let thumbnailHtml = getImageHtml(image);

		let questionsHtml = `<h2 class="text-center mb-0">`+itemProduct.title+`</h2>
						<button class="btn btn-back d-none d-md-block return_question2_back_btn">←</button>
						<div class="row exchange-item">
							<div class="col col-5 d-none d-md-block">
                        `+thumbnailHtml+`
					  </div>
					  <div class="col text-center text-md-left mt-2">
                        <span class="select-item-size">Size: `+item.variant.title+` | Quantity: `+item.qty+`</span>
                        <span class="d-block select-item-price">`+priceFormat.replace('0.00',item.price)+`</span>
                        <div class="w-100 text-left"><button class="btn btn-back d-md-none return_question2_back_btn py-0">←</button></div>

                              <div class="border m-1 p-3 text-left">
                                <h3>Is this item clean, in as new condition with the tags still attached?</h3>

                                <div class="row mx-1">
                                  <button class="btn btn-secondary q2-button px-4">Yes</button>

                                  <button class="btn btn-secondary q2-button px-4 ml-2">No</button>
                                </div>

                                <div class="row mx-1 mt-3">
                                  <b>Warning:</b> If the item is returned in bad condition you may not be eligible for a return.
                                  If you are unsure please contact our customer support.
                                </div>
                              </div>
						</div>`;
		$('#item_return_questions2').html(questionsHtml);

		$('.return_question2_back_btn').click(function(){
			$('#item_return_questions2').addClass('d-none');
			$('#item_return_questions1').removeClass('d-none');
		});

		$('.q2-button').click(function(){
            window.scrollTo(0, 0);
			loadReturnSureView(order, selectedVariant,returnReason,reasonNotes,productCount);
		});
	}

    let bundleBroken = false;

	function loadReturnSureView(order, selectedVariant,returnReason,reasonNotes,productCount) {
		$('#item_return_questions2').addClass('d-none');
		$('#item_return_sure').removeClass('d-none');
		let selectedProd = order.order_items[selectedVariant];
		let itemProduct = selectedProd.product;
		let itemVariant = selectedProd.variant;
		let item = selectedProd;

		let image = itemProduct.images[0];
		let thumbnailHtml = getImageHtml(image);
		let priceMinusDiscount = parseFloat(item.price) - (selectedProd.discount_allocations / item.qty);
		let exchangePrice = parseFloat(item.price)+parseFloat(extraDiscount);

		let altProducts = getSimilarPricedProducts(item.price,itemProduct,false,item.refundable);
		let altProductsHtml = '';
		$.each(altProducts,function(key,prod){
			let altImg = prod.images[0];
			altProductsHtml += '<div class="col-4 col-md-3 px-1">'+getImageHtml(altImg)+'</div>';
		});

		let orderTotal = 0;
		$.each(order.order_items, function(key,orderItem){
			if (!orderItem.returning) {
				orderTotal += parseFloat(orderItem.paid);
			}
		});

		let newOrderTotal = orderTotal - parseFloat(selectedProd.paid);

		let freeShippingAmount = parseFloat($('#find-order-form').attr('data-free-shipping-amount'));

        if (!bundleBroken && selectedProd.discount_title == 'Bundle 3 items') {
          priceMinusDiscount -= 20;
          bundleBroken = true;
        }

		let price = priceMinusDiscount;
		if (orderTotal > freeShippingAmount && newOrderTotal < freeShippingAmount) {
           price -= parseFloat($('#find-order-form').attr('data-shipping-cost'));
        }
        console.log(orderTotal+ ' '+ freeShippingAmount+'  '+newOrderTotal+' '+freeShippingAmount+' '+price+' '+item.price+' '+$('#find-order-form').attr('data-shipping-cost'));
        // let exchangeText = `Would you like to exchange for another item and <b>get `+priceFormat.replace('0.00',extraDiscount)+` added to your exchange credit?</b>`;
        // if (!item.refundable) {
        //   exchangeText = `Would you like to exchange for another item?`;
        // }
        let exchangeText = 'How would you like to process your return?';

		let questionsHtml = `<h2 class="text-center mb-0">`+itemProduct.title+`</h2>
                          <button class="btn btn-back d-none d-md-block return_sure_back_btn">←</button>
						<div class="row exchange-item">
							<div class="col col-5 d-none d-md-block">
                        `+thumbnailHtml+`
					  </div>
					  <div class="col text-center text-md-left mt-2">
                        <span class="select-item-size">Size: `+item.variant.title+` | Quantity: `+item.qty+`</span>
                        <span class="d-block select-item-price">`+priceFormat.replace('0.00',item.price)+`</span>
                        <div class="w-100 text-left"><button class="btn btn-back d-md-none return_sure_back_btn py-0">←</button></div>

                              <div class="border m-1 p-3">
                                <h3 class="text-left">`+exchangeText+`</h3>`+
                                // <div class="row mx-0">
                                //   `+altProductsHtml+`
                                // </div>
                                `<div class="row mt-3 align-items-center mx-1">
                                  <div class="col-12 col-md-4 px-2 px-md-0 mx-md-0">
                                    <button class="btn sure-buttons w-100 my-md-2 py-md-3" id="return-end-button" `+(item.refundable ? `` : `disabled`)+`>
                                      <span class="d-block">`+priceFormat.replace('0.00',price.toFixed(2))+`</span>
                                      Refund*
                                    </button>
                                  </div>`+
                                  // <div class="col-12 col-md-4 px-0 position-relative">
                                  //   <div class="position-absolute d-none d-md-block w-100 text-center earn-extra">
                                  //   <span `+(item.refundable ? `` : `class="d-none"`)+`>Earn `+priceFormat.replace('0.00',extraDiscount)+`</span>
                                  //   </div>
                                  //   <button class="btn sure-buttons text-left w-100 px-0 py-md-4 my-md-2 exchange-btn" id="return-exchange-button">

                                  //     <div class="earn-5-mob d-md-none `+(item.refundable ? `` : `d-none`)+`">Earn `+priceFormat.replace('0.00',extraDiscount)+`</div>
                                  //     <div class="text-center w-100">
                                  //     <span class="d-block">`+(item.refundable ? priceFormat.replace('0.00',exchangePrice.toFixed(2)) : priceFormat.replace('0.00',priceMinusDiscount.toFixed(2)))+`</span>
                                  //     Exchange
                                  //     </div>
                                  //   </button>
                                  // </div>
                                  `<div class="col-12 col-md-4 px-2 px-md-0 mx-md-0">
                                    <button class="btn sure-buttons w-100 py-md-3" id="return-store-credit-button">
                                      <span class="d-block">`+priceFormat.replace('0.00',priceMinusDiscount.toFixed(2))+`</span>
                                      Store Credit*
                                    </button>
                                  </div>
                                </div>
                  				<p class="mt-2 star-note">*`+(item.refundable ? `Invalidated discounts and shipping fees have been deducted from refund amount.` : `Items sold in a sale are only eligible for store credit. Invalidated discounts and shipping fees have been deducted from amount.`)+`</p>

                              </div>
						</div>`;
		$('#item_return_sure').html(questionsHtml);


		$('.return_sure_back_btn').click(function(){
			$('#item_return_sure').addClass('d-none');
			$('#item_return_questions2').removeClass('d-none');
		});

		$('#return-exchange-button').click(function(){
			$('#item_return_sure').addClass('d-none');
			loadExchangeOtherView(order, selectedVariant);
		});

		$('#return-store-credit-button').click(function(){
			//selectedProd.returning = true;
			$('.order-item').each(function(){
				if ($(this).attr('data-variant-id') == selectedVariant && $(this).attr('data-count') == productCount) {
				  $(this).find('.exchange-selected').remove();
                  $(this).parent().find('.exchange-selected').remove();
                  $(this).append('<div class="col-12 col-md-2 position-relative exchange-selected refund-exchange-selected text-center align-items-center d-flex" data-reason="'+returnReason+'" data-reason-notes="'+encodeURIComponent(reasonNotes)+'" data-from="'+itemVariant.id+'" data-to="Store Credit"><div class="w-100"><span>$'+priceFormat.replace('0.00',priceMinusDiscount.toFixed(2))+'</span>Store Credit</div><div class="position-absolute remove-selection">x</div></div>');
				  $('.exchange-selected').click(function(e){
					e.stopImmediatePropagation();
    			  });
				  $('.remove-selection').click(function(e){
					e.stopImmediatePropagation();
       				$(this).parent().remove();
                    checkContinueValid();
    			  });
				  $('.continue-btn').removeClass('d-none');
				}
			});
			$('#item_return_sure').addClass('d-none');
			$('#order_details').removeClass('d-none');
		});


		$('#return-end-button').click(function(){
			selectedProd.returning = true;
			$('.order-item').each(function(){
				if ($(this).attr('data-variant-id') == selectedVariant && $(this).attr('data-count') == productCount) {
				  $(this).find('.exchange-selected').remove();
                  $(this).parent().find('.exchange-selected').remove();
                  $(this).append('<div class="col-12 col-md-2 position-relative exchange-selected refund-exchange-selected text-center align-items-center d-flex" data-reason="'+returnReason+'" data-reason-notes="'+encodeURIComponent(reasonNotes)+'" data-from="'+itemVariant.id+'" data-to="Refund"><div class="w-100"><span>$'+priceFormat.replace('0.00',price.toFixed(2))+'</span>Refund</div><div class="position-absolute remove-selection">x</div></div>');
				  $('.exchange-selected').click(function(e){
					e.stopImmediatePropagation();
    			  });
				  $('.remove-selection').click(function(e){
					e.stopImmediatePropagation();
       				$(this).parent().remove();
                    checkContinueValid();
    			  });
				  $('.continue-btn').removeClass('d-none');
				}
			});
			$('#item_return_sure').addClass('d-none');
			$('#order_details').removeClass('d-none');
		});
	}

	$('#notes_back_btn').click(function(){
		$('#return_notes').addClass('d-none');
		$('#order_details').removeClass('d-none');
	});


    $('#process-exchange').click(function(){
		let returnItems = [];
		$('.exchange-selected').each(function(){
			returnItems.push({
                  reason: $(this).attr('data-reason'),
                  reason_notes:($(this).attr('data-reason-notes')) ? decodeURIComponent($(this).attr('data-reason-notes')) : '',
                  from: $(this).attr('data-from'),
                  to: $(this).attr('data-to')
              });
		});

		$.ajax({
            url:'https://dashboard.cadenshae.co.nz/customerrefundorder',
            method:'POST',
			data: JSON.stringify({
				country: $('#country_code').val(),
				order_number: $('#order_number').val(),
				email: $('#order_email').val(),
				notes: $('#extra-notes').val(),
				items: returnItems
			}),
			statusCode: {
              404: function() {

              }
  			}
        }).done(function (res) {
			console.log(res);
			$('#return_notes').addClass('d-none');
			$('#final_info').removeClass('d-none');
		});

	});


	function getImageHtml(image) {
		let thumbnailHtml = '<picture class="picker-thumbnails">';

     	let sizeWidths = Object.keys(image.sizes).reverse();
    	let sizes = Object.values(image.sizes).reverse();
     	$.each(sizes,function(key,size) {
     	  if (key >= sizes.length-2) {
    		return;
   		  }
   		  thumbnailHtml += '<source media="(min-width: '+sizeWidths[key+1]+'px)" srcset="'+size+'">';
   		});
  		thumbnailHtml += '<img class="img-fluid" src="'+image.sizes['105']+'" alt="'+image.alt+'">'+
  		'</picture>';

		return thumbnailHtml;
	}

	function getSimilarPricedProducts(price,compareProduct,all,refundable) {
		let priceBuffer = extraDiscount*100;
        if (!refundable) {
          priceBuffer = 1*100;
        }
		let similar = {};
		let typesFound = [];
		$.each(allProductsWithStock,function(pkey, product){
			if (Math.abs(product.price - (price*100)) < priceBuffer && product.online && !product.title.includes('Non BF') && !typesFound.includes(product.type) && !product.title.includes('** CLEARANCE **')) {
              if (all || typesFound.length < 3) {
                similar[pkey] = product;
              }

              if (!all) {
                typesFound.push(product.type);
              }
            }
		});
        return similar;
	}

});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["size-quiz-bottoms"]) return;
  try {
    
  $('.bottom-clickable').click(function(){
    let selectedVal = $('input[name="bottom_size"]:checked').val();
    $('[name="band_size"]').removeAttr('checked');
    $("input[name=band_size][value=" + selectedVal + "]").prop('checked', true);
  });

  $('.band-clickable').click(function(){
    let selectedVal = $('input[name="band_size"]:checked').val();
    $('[name="bottom_size"]').removeAttr('checked');
    $("input[name=bottom_size][value=" + selectedVal + "]").prop('checked', true);
  });


      $('.size-quiz-bottoms .start-btn').on('click', function () {
          setTimeout(function () {
              $('.mobile-scroll').scrollLeft(60);
          }, 10);
      });


      $('.size-quiz-bottoms #slide3-btn-2').on('click', function () {
          if (!$('input[name=stage]:checked').val()) {
              $('input[name=stage]').eq(1).prop("checked", true);
          }
      });


      let stages = ['1st Trimester', '1st Trimester', '2nd Trimester', '3rd Trimester', 'Postpartum', 'Neither, just love Cadenshae!', 'Neither, just love Cadenshae!'];
      addMobileSlider("jssor_bt_1", stages, '.pregnancy-stage', 550, 'stage');



      function addMobileSlider(elementId, selectionTexts, parentSelector, slideWidth, radioName) {
          window.jssor_1_slider_init = function () {

              var slider_options = {
                  $AutoPlay: 0,
                  $SlideWidth: slideWidth,
                  $Loop: 0,
                  $StartIndex: 2
              };

              var slider = new $JssorSlider$(elementId, slider_options);

              slider.$On($JssorSlider$.$EVT_PARK, function (slideIndex, fromIndex) {
                  var slideIndex2 = Math.round(slider.$CurrentPosition());
                  $(parentSelector).find('.slider-text').text(selectionTexts[slideIndex2]);

                  if (slideIndex2 == 0) {
                      slider.$PlayTo(1);
                  }
                  if (slideIndex2 == slider.$SlidesCount() - 1) {
                      slider.$PlayTo(slider.$SlidesCount() - 2);
                  }

                  $('input[name=' + radioName + ']').each(function (index) {
                      if (index + 1 == slideIndex2) {
                          $(this).prop("checked", true);
                      } else {
                          $(this).prop("checked", false);
                      }
                  });
                  if (typeof refreshSelected === 'function') refreshSelected();

              });

              /*#region responsive code begin*/

              var MAX_WIDTH = 980;

              function ScaleSlider() {
                  var containerElement = slider.$Elmt.parentNode;
                  var containerWidth = containerElement.clientWidth;

                  if (containerWidth) {
                      var expectedWidth = Math.min(MAX_WIDTH || containerWidth, containerWidth);
                      slider.$ScaleWidth(expectedWidth);
                  } else {
                      window.setTimeout(ScaleSlider, 30);
                  }
              }

              ScaleSlider();

              $Jssor$.$AddEvent(window, "load", ScaleSlider);
              $Jssor$.$AddEvent(window, "resize", ScaleSlider);
              $Jssor$.$AddEvent(window, "orientationchange", ScaleSlider);
              /*#endregion responsive code end*/
          };
          jssor_1_slider_init();
      }


      $(window).resize(function () {
          displayRadioBar();
      });

      function displayRadioBar() {
          setTimeout(function () {
              radioBarPositioning(".pregnancy-stage");
          }, 1000);
      }

      function radioBarPositioning(selector) {
          let firstRadioPos = $(selector).find(".fit-first-radio").offset();
          let newLeft = firstRadioPos.left + 7;
          let lastRadioPos = $(selector).find(".fit-last-radio").offset();
          let newWidth = (lastRadioPos.left - newLeft) + 3;
          let newTop = firstRadioPos.top + 7;
          $(selector).find(".fit-bar").css({top: newTop, left: newLeft, width: newWidth});
      }

      $('.size-quiz-bottoms .carousel').carousel('pause');

      $('input').on('input', function () {
          if ($('input[name=bottom_size]:checked').val()) {
              $('#slide2-btn').prop('disabled', false);
          }
          if ($('input[name=height]:checked').val()) {
              $('#slide3-btn').prop('disabled', false);
          }
          if ($('input[name=stage]:checked').val()) {
              $('#slide4-btn').prop('disabled', false);
          }
          if ($('#email').is(':valid')) {
              $('#slide5-btn').prop('disabled', false);
          }
      });

      $('.size-quiz-bottoms .back-btn').on('click', function () {
          $('.carousel').carousel('prev');
          displayRadioBar();
      });

      $('.size-quiz-bottoms .next-btn').on('click', function () {
          $('.carousel').carousel('next');
          displayRadioBar();
      });

      function getAnswers() {
          let stages = ['1st Trimester', '2nd Trimester', '3rd Trimester', 'Postpartum', 'Neither'];

          return {
              'bottom': $('input[name=bottom_size]:checked').val(),
              'height': $('input[name=height]:checked').val(),
              'email': $('#email').val(),
              'stage': stages[$('input[name=stage]:checked').val()]
          };
      }

      $('.size-quiz-bottoms #slide5-btn').on('click', function () {
          let answers = getAnswers();
          updateUrl(answers);
  		fbq('track', 'Lead');

          _learnq.push(['identify', {
              '$email': answers.email,
              'Pregnancy Stage': answers.stage,
              'Height': answers.height,
              'Bottom Size': answers.bottom
          }]);

  		_learnq.push(['track', 'Bottoms Quiz', {
              'items': klavyoItems
          }]);

      });

      $('.size-quiz-bottoms #not-now-btn').on('click', function () {
          updateUrl(getAnswers());
      });

      $('.size-quiz-bottoms #restart-quiz').click(function(e) {
  		e.preventDefault();
  		localStorage.removeItem("quiz-results-bottoms");
  		window.location = '/pages/size-quiz-bottoms';
  	});

      function updateUrl(answers) {
          let queryString = $.param(answers);
          window.history.pushState(" ", "Quiz Results", "?" + queryString);
  		localStorage.setItem("quiz-results-bottoms", queryString);
      }

      $(document).ready(function() {
          let queryVars = getUrlVars();
          if (queryVars.bottom) {
              loadProducts(queryVars);
              $('.size-quiz-bottoms .carousel').carousel(5);
          }
      });

      function getUrlVars() {
          var vars = [], hash;
          var hashes = [];
  		if (window.location.href.indexOf('?') > 0) {
  			hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
  		} else if (localStorage.getItem("quiz-results-bottoms")) {
  			hashes = localStorage.getItem("quiz-results-bottoms").split('&');
  		}
  		for(var i = 0; i < hashes.length; i++)
          {
              hash = hashes[i].split('=');
              vars.push(hash[0]);
              vars[hash[0]] = decodeURI(hash[1]);
          }

          return vars;
      }


      $('.size-quiz-bottoms #slide4-btn').on('click', function () {
          loadProducts(getAnswers());
      });

      $('.size-quiz-bottoms #slide4-btn-2').on('click', function () {
          loadProducts(getAnswers());
      });

      /* ==========================================================================
         BOTTOMS RECOMMENDATION RULES  (updated Oct 2026)
         --------------------------------------------------------------------------
         1. Her size comes from her bottoms size / hip measurement (SIZE_BY_BOTTOM).
         2. stages: which customers see the style. 'pregnant' = 1st-3rd trimester,
            'after' = Postpartum or "Neither, just love Cadenshae!".
         3. compression: true adds the firm belly band note and a "size up" link.
         4. length: true means the product has Short / Long options, picked from
            her height answer (under 160cm = Short, over 160cm = Long).
         5. The quiz shows up to `show` colourways that have her size in stock.
            If none do, the style is hidden (see SHOW_OUT_OF_STOCK to change that).
         To add a new style or colourway, add it to the list below.
         ========================================================================== */

      // false = hide a style when it's sold out in her size. true = show it with
      // an "out of stock, get notified" link instead.
      const SHOW_OUT_OF_STOCK = false;

      const SIZE_BY_BOTTOM = { 6: 'XS', 8: 'XS', 10: 'S', 12: 'M', 14: 'L', 16: 'XL', 18: '2XL', 20: '3XL' };
      const BOTTOM_SIZE_ORDER = ['XXS', 'XS', 'S', 'M', 'L', 'XL', '2XL', '3XL'];

      const BOTTOM_STYLES = [
          {
              name: 'Classic Maternity Leggings 7/8',
              stages: ['pregnant', 'after'],
              compression: true,
              show: 1,
              handles: ['pregnancy-leggings-7-8-length-pockets-black']
          },
          {
              name: 'Classic Maternity Bike Shorts',
              stages: ['pregnant', 'after'],
              compression: true,
              show: 1,
              handles: ['high-waisted-bike-shorts-pockets-black']
          },
          {
              name: 'Power FIT 2.0 Tights 7/8',
              stages: ['after'],
              compression: true,
              show: 1,
              handles: ['power-fit-high-waisted-tights-black']
          },
          {
              name: 'Power FIT 2.0 Bike Shorts',
              stages: ['after'],
              compression: true,
              show: 1,
              handles: ['power-fit-bike-shorts-black', 'high-waisted-running-bike-shorts-power-fit-2-0']
          },
          {
              name: 'Wide Leg Ribbed Pants',
              stages: ['after'],
              length: true,
              show: 2,
              handles: ['wide-leg-ribbed-pants', 'wide-leg-ribbed-pants-rust']
          }
      ];

      // Finds the variant for a size (and Short / Long when the product has it).
      // Works for "M", "M / Black", "M / Short".
      function findBottomVariant(product, size, lengthWanted) {
          let match = null;
          product.variants.forEach(function (variant) {
              if (match) return;
              let parts = variant.title.toUpperCase().split('/').map(function (p) { return p.trim(); });
              if (parts[0] !== size) return;
              let lengthPart = parts.find(function (p) { return p === 'SHORT' || p === 'LONG'; });
              if (lengthPart && lengthWanted && lengthPart !== lengthWanted) return;
              match = variant;
          });
          return match;
      }

      function getBottomRecommendations(answers, allProducts) {
          let size = SIZE_BY_BOTTOM[parseInt(answers.bottom)];
          if (!size) return [];
          let stageGroup = ['1st Trimester', '2nd Trimester', '3rd Trimester'].includes(answers.stage) ? 'pregnant' : 'after';
          let lengthWanted = answers.height === 'low' ? 'SHORT' : 'LONG';
          let sizeUp = BOTTOM_SIZE_ORDER[BOTTOM_SIZE_ORDER.indexOf(size) + 1] || null;
          let recs = [];

          BOTTOM_STYLES.forEach(function (style) {
              if (!style.stages.includes(stageGroup)) return;
              let inStock = [];
              let fallback = null;
              style.handles.forEach(function (handle) {
                  if (inStock.length >= style.show) return;
                  let product = allProducts[handle];
                  if (!product || product.online === false) return;
                  let variant = findBottomVariant(product, size, style.length ? lengthWanted : null);
                  if (!variant) return;
                  let upVariant = (style.compression && sizeUp) ? findBottomVariant(product, sizeUp, null) : null;
                  let rec = {
                      product: product,
                      variant: variant,
                      size: size,
                      compression: !!style.compression,
                      sizeUp: sizeUp,
                      upVariant: upVariant,
                      lengthLabel: style.length ? (lengthWanted === 'SHORT' ? 'Short' : 'Long') : ''
                  };
                  if (variant.available) inStock.push(rec);
                  else if (!fallback) fallback = rec;
              });
              if (inStock.length) recs = recs.concat(inStock);
              else if (fallback && SHOW_OUT_OF_STOCK) recs.push(fallback);
          });
          return recs;
      }

      let klavyoItems = [];
      function loadProducts(answers) {
          allProductsLoader(function (allProducts) {
              // the loader can call back twice (cache then fresh), so start clean each time
              klavyoItems = [];
              $('#product-results').empty();
              $('.size-quiz-bottoms .no-results').remove();

              let recs = getBottomRecommendations(answers, allProducts);
              if (!recs.length) {
                  $('#product-results').after(
                      '<div class="no-results text-center my-5">' +
                      '<p>We don\'t have bottoms in stock in your size right now.</p>' +
                      '<p>Check the <a href="/pages/size-guide">size chart</a> or flick us a message and we\'ll help you find your fit.</p>' +
                      '</div>'
                  );
                  return;
              }
              recs.forEach(function (rec) {
                  displayLoadedProduct(rec, allProducts);
              });
          });
      }

      // The store's money format has no cents ("$0 NZD"), so swap the number in
      // rather than looking for "0.00". Shows cents only when the price has them.
      function formatPrice(cents) {
          let amount = Number(cents) / 100;
          let shown = (amount % 1 === 0) ? String(amount) : amount.toFixed(2);
          let fmt = $('.size-quiz-bottoms').attr('data-price-format') || '$0';
          return fmt.replace(/\d+(?:[.,]\d+)?/, shown);
      }

      function displayLoadedProduct(rec, allProducts) {
          let product = $.extend(true, {}, rec.product);
          let size = rec.size;
          let variantId = rec.variant.id;
          let available = rec.variant.available;

          let klavyoProduct = $.extend(true, {}, product);
          klavyoProduct.selectedSize = size;
          klavyoProduct.selectedVariant = variantId;
          klavyoProduct.selectedVariantAvailable = available;
          klavyoProduct.description = '';
          klavyoItems.push(klavyoProduct);

          let imagesHtml = '';
          let mainImg = '';
          let mainAlt = '';
          if (product.images && product.images.length) {
              let sizeWidths = Object.keys(product.images[0].sizes).reverse();
              let sizes = Object.values(product.images[0].sizes).reverse();
              $.each(sizes, function (key, imgsize) {
                  if (key >= sizes.length - 2) {
                      return;
                  }
                  imagesHtml += '<source media="(min-width: ' + sizeWidths[key + 1] + 'px)" srcset="' + imgsize + '">';
              });
              mainImg = product.images[0].sizes[105];
              mainAlt = product.images[0].alt;
          }

          let price = formatPrice(rec.variant.price || product.price);

          // Colour swatches: only shown when there are 2+ colours live, and any swatch
          // whose image is missing from the theme hides itself instead of showing broken.
          let colourHtml = '';
          let colourCount = 0;
          $.each(product.colour_group || [], function (key, handle) {
              if (allProducts.hasOwnProperty(handle) && allProducts[handle].online && allProducts[handle].swatch) {
                  colourCount++;
                  colourHtml += '<a href="/products/' + handle + '" data-handle="' + handle + '" class="colour-picker rounded-circle mr-2 ' + (handle == product.handle ? 'border' : '') + '">' +
                      '<img class="rounded-circle alt-colour" src="' + allProducts[handle].swatch + '" alt="" onerror="this.parentNode.style.display=\'none\'">' +
                      '</a>';
              }
          });
          if (colourCount < 2) colourHtml = '';

          let displayTitle = product.colour ? product.title.replace(product.colour, '') : product.title;
          let sizeText = 'Size ' + size + (rec.lengthLabel ? ' ' + rec.lengthLabel : '');

          let fitNote = '';
          if (rec.compression) {
              fitNote = '<span class="size-note d-block mb-2">Compression fit with a firm belly band.';
              if (rec.upVariant) {
                  fitNote += ' Don\'t like things tight? <a href="/products/' + product.handle + '?variant=' + rec.upVariant.id + '">Size up to ' + rec.sizeUp + '</a>' +
                      (rec.upVariant.available ? '' : ' (out of stock)');
              }
              fitNote += '</span>';
          }

          let template = '<div class="col col-9 col-md-4 product-col">' +
              '<div class="container grid-item pb-0">' +
                '<div class="main-image-frame position-relative">' +
                  '<a href="/products/' + product.handle + '?variant=' + variantId + '">' +
                    '<picture class="main-image">' +
                      imagesHtml +
                      '<img class="img-fluid" src="' + mainImg + '" alt="' + mainAlt + '">' +
                    '</picture>' +
                    '<span class="d-none plus-symbol" data-handle="' + product.handle + '" data-varaint-id="' + variantId + '" data-toggle="modal" data-target="#other-product-modal">+</span>' +
                  '</a>' +
                '</div>' +
                '<div class="row details">' +
                  '<div class="col py-2 text-center">' +
                    '<span class="no-wrap d-block"><a href="/products/' + product.handle + '?variant=' + variantId + '">' +
                      displayTitle + '</a></span>' +
                    '<span class="price mb-2">' + price + '</span>' +
                    fitNote +
                    '<div class="colour-pickers" data-handle="' + product.handle + '">' +
                      colourHtml +
                    '</div>' +
                    (available ?
                      '<a href="/products/' + product.handle + '?variant=' + variantId + '" class="btn add-to-cart" data-handle="' + product.handle + '" data-variant-title="' + rec.variant.title + '" data-variant-id="' + variantId + '" data-product-title="' + product.title + '" data-image-url="' + mainImg + '" data-price="' + price + '">' +
                        sizeText + ' - Add to cart</a>'
                      : '<a href="/products/' + product.handle + '?variant=' + variantId + '" class="d-block">' + sizeText + ' - Out of stock, get notified</a>') +
                  '</div>' +
                '</div>' +
              '</div>' +
            '</div>';

          $('#product-results').append(template);
          addQuickViewEvent(product);
      }

    function addQuickViewEvent(product) {
      $('#quiz-slider-bottoms').find('.quick-view-button').click(function(e) {
        e.preventDefault();
      });

      $('.size-quiz-bottoms .main-image-frame').off('hover');
      $('.size-quiz-bottoms .main-image-frame').hover(function(){
        $(this).find('.quick-view-button').addClass('hovered');
      },function(){
        $(this).find('.quick-view-button').removeClass('hovered');
      });

      $('#quiz-slider-bottoms .plus-symbol').off('click');
      $('#quiz-slider-bottoms .plus-symbol').click(function(e){e.preventDefault();});

      // The "Add to cart" button opens the product page with her size selected,
      // same as before (the side cart was switched off on this quiz).
    }

      // Highlight picked options and show what she's chosen so far
      function refreshSelected() {
          let stageInputs = document.querySelectorAll('.size-quiz-bottoms input[name="stage"]');
          let anyStage = false;
          stageInputs.forEach(function (input) {
              let label = input.closest('label');
              if (!label) return;
              label.classList.toggle('is-selected', input.checked);
              if (input.checked) anyStage = true;
          });
          let stageSlide = document.querySelector('.size-quiz-bottoms .pregnancy-stage');
          if (stageSlide) stageSlide.classList.toggle('has-selection', anyStage);

          let band = document.querySelector('.size-quiz-bottoms input[name="band_size"]:checked');
          let hip = document.querySelector('.size-quiz-bottoms input[name="bottom_size"]:checked');
          let labelText = function (input) {
              let l = document.querySelector('.size-quiz-bottoms label[for="' + input.id + '"]');
              return l ? l.textContent.replace(/\s+/g, ' ').replace(/cm.*$/, 'cm').trim() : input.value;
          };
          let picked = document.querySelector('.size-quiz-bottoms .picked-size');
          if (picked) {
              let bits = [];
              if (band) bits.push('Size <strong>' + labelText(band) + '</strong>');
              if (hip) bits.push('hips <strong>' + labelText(hip) + '</strong>');
              picked.innerHTML = bits.length ? 'You picked: ' + bits.join(', ') : '';
          }
      }
      document.querySelectorAll('.size-quiz-bottoms input[type="radio"]').forEach(function (input) {
          input.addEventListener('change', refreshSelected);
          input.addEventListener('input', refreshSelected);
      });
      // the size and hip pickers tick each other in code, so refresh after any tap
      document.querySelectorAll('.size-quiz-bottoms .band-clickable, .size-quiz-bottoms .bottom-clickable, .size-quiz-bottoms .next-btn, .size-quiz-bottoms .back-btn').forEach(function (el) {
          el.addEventListener('click', function () { setTimeout(refreshSelected, 50); });
      });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["size-quiz-tops"]) return;
  try {
    
  let sizeLinks = [
    {size:6,cupC:80,cupD:85},
    {size:8,cupC:85,cupD:91},
    {size:10,cupC:91,cupD:96},
    {size:12,cupC:96,cupD:101},
    {size:14,cupC:101,cupD:106},
    {size:16,cupC:106,cupD:111},
    {size:18,cupC:111,cupD:116},
    {size:20,cupC:121,cupD:121},
    {size:22,cupC:121,cupD:121}
  ];

  $('.size-clickable').click(function(){
    let selectedBust = $('input[name="bust_size"]:checked').val();
    let selectedTop = $('input[name="top_size"]:checked').val();

    sizeLinks.every(function(link) {
      if (link.size == selectedTop) {
        if (link.cupC != selectedBust && link.cupD != selectedBust) {
          $("input[name=bust_size][value=" + link.cupC + "]").prop('checked', true);
          return false;
        }
      }
      return true;
    });

  });

  $('.bust-clickable').click(function(){
    let selectedBust = $('input[name="bust_size"]:checked').val();
    let selectedTop = $('input[name="top_size"]:checked').val();

    sizeLinks.every(function(link) {
      if (link.size == selectedTop || !selectedTop) {
        if (link.cupC != selectedBust && link.cupD != selectedBust) {
          sizeLinks.every(function(link) {
  			if (link.cupC == selectedBust || link.cupD == selectedBust) {
  				$("input[name=top_size][value=" + link.size + "]").prop('checked', true);
  				return false;
  			}
  			return true;
  		});

          return false;
        }
      }
      return true;
    });

  });


  $('.cup-clickable').click(function() {
    let selectedCup = $('input[name="cup_size"]:checked').val();
    let selectedBust = $('input[name="bust_size"]:checked').val();
    let selectedTop = $('input[name="top_size"]:checked').val();

    sizeLinks.every(function(link){
      if (['A','B','C'].includes(selectedCup)) {
        if (link.cupC == selectedBust) {
          $('[name="top_size"]').removeAttr('checked');
          $("input[name=top_size][value=" + link.size + "]").prop('checked', true);
          return false;
        }
      } else {
        if (link.cupD == selectedBust) {
          $('[name="top_size"]').removeAttr('checked');
          $("input[name=top_size][value=" + link.size + "]").prop('checked', true);
          return false;
        }
      }
      return true;
    });

  });




      $('.size-quiz-tops .start-btn').on('click', function () {
          setTimeout(function () {
              $('.mobile-scroll').scrollLeft(60);
          }, 10);
      });


      $('.size-quiz-tops #slide3-btn-2').on('click', function () {
          if (!$('input[name=stage]:checked').val()) {
              $('input[name=stage]').eq(1).prop("checked", true);
          }
      });


      let stages = ['1st Trimester', '1st Trimester', '2nd Trimester', '3rd Trimester', 'Postpartum', 'Neither, just love Cadenshae!', 'Neither, just love Cadenshae!'];
      addMobileSlider("jssor_bt_1", stages, '.pregnancy-stage', 550, 'stage');



      function addMobileSlider(elementId, selectionTexts, parentSelector, slideWidth, radioName) {
          window.jssor_1_slider_init = function () {

              var slider_options = {
                  $AutoPlay: 0,
                  $SlideWidth: slideWidth,
                  $Loop: 0,
                  $StartIndex: 2
              };

              var slider = new $JssorSlider$(elementId, slider_options);

              slider.$On($JssorSlider$.$EVT_PARK, function (slideIndex, fromIndex) {
                  var slideIndex2 = Math.round(slider.$CurrentPosition());
                  $(parentSelector).find('.slider-text').text(selectionTexts[slideIndex2]);

                  if (slideIndex2 == 0) {
                      slider.$PlayTo(1);
                  }
                  if (slideIndex2 == slider.$SlidesCount() - 1) {
                      slider.$PlayTo(slider.$SlidesCount() - 2);
                  }

                  $('input[name=' + radioName + ']').each(function (index) {
                      if (index + 1 == slideIndex2) {
                          $(this).prop("checked", true);
                      } else {
                          $(this).prop("checked", false);
                      }
                  });
                  if (typeof refreshSelected === 'function') refreshSelected();

              });

              /*#region responsive code begin*/

              var MAX_WIDTH = 980;

              function ScaleSlider() {
                  var containerElement = slider.$Elmt.parentNode;
                  var containerWidth = containerElement.clientWidth;

                  if (containerWidth) {
                      var expectedWidth = Math.min(MAX_WIDTH || containerWidth, containerWidth);
                      slider.$ScaleWidth(expectedWidth);
                  } else {
                      window.setTimeout(ScaleSlider, 30);
                  }
              }

              ScaleSlider();

              $Jssor$.$AddEvent(window, "load", ScaleSlider);
              $Jssor$.$AddEvent(window, "resize", ScaleSlider);
              $Jssor$.$AddEvent(window, "orientationchange", ScaleSlider);
              /*#endregion responsive code end*/
          };
          jssor_1_slider_init();
      }


      $(window).resize(function () {
          displayRadioBar();
      });

      function displayRadioBar() {
          setTimeout(function () {
              radioBarPositioning(".pregnancy-stage");
          }, 1000);
      }

      function radioBarPositioning(selector) {
          let firstRadioPos = $(selector).find(".fit-first-radio").offset();
          let newLeft = firstRadioPos.left + 7;
          let lastRadioPos = $(selector).find(".fit-last-radio").offset();
          let newWidth = (lastRadioPos.left - newLeft) + 3;
          let newTop = firstRadioPos.top + 7;
          $(selector).find(".fit-bar").css({top: newTop, left: newLeft, width: newWidth});
      }

      $('.size-quiz-tops .carousel').carousel('pause');

      $('input').on('input', function () {
  		if ($('input[name=top_size]:checked').val()) {
              $('#slide2-btn').prop('disabled', false);
          }
          if ($('input[name=cup_size]:checked').val()) {
              $('#slide3-btn').prop('disabled', false);
          }
          if ($('input[name=stage]:checked').val()) {
              $('#slide4-btn').prop('disabled', false);
          }
          if ($('#email').is(':valid')) {
              $('#slide5-btn').prop('disabled', false);
          }
      });

      $('.size-quiz-tops .back-btn').on('click', function () {
          $('.carousel').carousel('prev');
          displayRadioBar();
      });

      $('.size-quiz-tops .next-btn').on('click', function () {
          $('.carousel').carousel('next');
          displayRadioBar();
      });

      function getAnswers() {
          let stages = ['1st Trimester', '2nd Trimester', '3rd Trimester', 'Postpartum', 'Neither'];

          return {
              'top': $('input[name=top_size]:checked').val(),
              'cup': $('input[name=cup_size]:checked').val(),
  			'bust': $('input[name=bust_size]:checked').val(),
              'email': $('#email').val(),
              'stage': stages[$('input[name=stage]:checked').val()]
          };
      }

      $('.size-quiz-tops #slide5-btn').on('click', function () {
          let answers = getAnswers();
          updateUrl(answers);
  		fbq('track', 'Lead');

          _learnq.push(['identify', {
              '$email': answers.email,
              'Pregnancy Stage': answers.stage,
              'Cup Size': answers.cup,
  			'Bust Size': answers.bust,
              'Top Size': answers.top
          }]);

  		_learnq.push(['track', 'Tops Quiz', {
              'items': klavyoItems
          }]);

      });

      $('.size-quiz-tops #not-now-btn').on('click', function () {
          updateUrl(getAnswers());
      });

      $('.size-quiz-tops #restart-quiz').click(function(e) {
  		e.preventDefault();
  		localStorage.removeItem("quiz-results-tops");
  		window.location = '/pages/size-quiz-tops';
  	});

      function updateUrl(answers) {
          let queryString = $.param(answers);
          window.history.pushState(" ", "Quiz Results", "?" + queryString);
  		localStorage.setItem("quiz-results-tops", queryString);
      }

      $(document).ready(function() {
          let queryVars = getUrlVars();
          if (queryVars.top) {
              loadProducts(queryVars);
              $('.size-quiz-tops .carousel').carousel(5);
          }
      });

      function getUrlVars() {
          var vars = [], hash;
          var hashes = [];
  		if (window.location.href.indexOf('?') > 0) {
  			hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
  		} else if (localStorage.getItem("quiz-results-tops")) {
  			hashes = localStorage.getItem("quiz-results-tops").split('&');
  		}
  		for(var i = 0; i < hashes.length; i++)
          {
              hash = hashes[i].split('=');
              vars.push(hash[0]);
              vars[hash[0]] = decodeURI(hash[1]);
          }

          return vars;
      }

      $('.size-quiz-tops #slide4-btn').on('click', function () {
          loadProducts(getAnswers());
      });

      $('.size-quiz-tops #slide4-btn-2').on('click', function () {
          loadProducts(getAnswers());
      });

      /* ==========================================================================
         TOP RECOMMENDATION RULES  (updated Oct 2026)
         --------------------------------------------------------------------------
         1. Her "true size" comes from bust measurement + cup (SIZE_BY_BUST below,
            same chart the quiz has always used).
         2. Each style then shifts that size: -1 = size down one (oversized fits).
         3. Breastfeeding / Non-Breastfeeding: everyone gets the Breastfeeding version
            except "Neither, just love Cadenshae!", who gets Non-Breastfeeding.
         4. For each style the quiz shows up to `show` colourways that have her size
            in stock. If none do, it shows one as "out of stock".
         To add a new colourway, add its handle to the style's list.
         ========================================================================== */

      const SIZE_BY_BUST = {
          // bust value (cm) : [A-C cup size, D+ cup size]
          80:  ['XS',  'XS'],
          85:  ['XS',  'S'],
          91:  ['S',   'M'],
          96:  ['M',   'L'],
          101: ['L',   'XL'],
          106: ['XL',  '2XL'],
          111: ['2XL', '2XL'],
          116: ['2XL', '3XL'],
          121: ['3XL', '3XL']
      };
      const TOP_SIZE_ORDER = ['XXS', 'XS', 'S', 'M', 'L', 'XL', '2XL', '3XL'];
      function shiftTopSize(size, steps) {
          let i = TOP_SIZE_ORDER.indexOf(size) + steps;
          i = Math.max(0, Math.min(TOP_SIZE_ORDER.length - 1, i));
          return TOP_SIZE_ORDER[i];
      }

      // only: 'bf' = breastfeeding-only product, 'nonbf' = non-breastfeeding-only product.
      // Leave it off for products that have a Breastfeeding / Non-Breastfeeding option.
      const TOP_STYLES = [
          {
              name: 'Charlotte Tee',
              shift: -1,
              note: 'Oversized fit, so we\'ve sized you down',
              show: 3,
              handles: [
                  { handle: 'charlotte-tee-6' },
                  { handle: 'breastfeeding-t-shirt-charlotte-tee-1' },
                  { handle: 'charlotte-tee-desert-rose' },
                  { handle: 'charlotte-tee-4' },
                  { handle: 'breastfeeding-t-shirt-charlotte-tee-black' },
                  { handle: 'charlotte-tee-woodland' },
                  { handle: 'breastfeeding-t-shirt-charlotte-tee-ivory' },
                  { handle: 'breastfeeding-t-shirt-charlotte-tee-lemon-kiss' },
                  { handle: 'charlotte-tee-3' },
                  { handle: 'charlotte-tee-vanilla-sand' },
                  { handle: 'charlotte-tee-5' }
              ]
          },
          {
              name: 'Retreat Hoodie',
              shift: -1,
              note: 'Oversized fit, so we\'ve sized you down',
              show: 2,
              handles: [
                  { handle: 'oversized-cosy-hoodie-retreat-hoodie-bonsai-copy' },
                  { handle: 'oversized-cosy-hoodie-retreat-hoodie-1' },
                  { handle: 'oversized-cosy-hoodie-retreat-hoodie-sage' },
                  { handle: 'oversized-cosy-hoodie-retreat-hoodie-riverstone' },
                  { handle: 'oversized-cosy-hoodie-retreat-hoodie' },
                  { handle: 'oversized-cosy-hoodie-retreat-hoodie-bonsai' }
              ]
          },
          {
              name: 'Jackson Crew',
              shift: 0,
              note: 'Roomy fit, size down if you\'re between sizes',
              show: 1,
              handles: [
                  { handle: 'breastfeeding-sweatshirt-jackson-crew-1' },
                  { handle: 'breastfeeding-sweatshirt-jackson-crew-2' },
                  { handle: 'breastfeeding-sweatshirt-jackson-black', only: 'bf' },
                  { handle: 'womens-sweatshirt-jackson-crew-black', only: 'nonbf' }
              ]
          },
          {
              name: 'Columbia Tank',
              shift: 0,
              note: '',
              show: 1,
              handles: [
                  { handle: 'breastfeeding-tank-columbia-tank-seafoam-stripe', only: 'bf' },
                  { handle: 'breastfeeding-tank-columbia-tank', only: 'bf' },
                  { handle: 'breastfeeding-tank-columbia-tank-1', only: 'bf' },
                  { handle: 'breastfeeding-tank-columbia-tank-2', only: 'bf' }
              ]
          }
      ];

      // Finds the variant for a size, and the right Breastfeeding / Non-Breastfeeding
      // option when the product has one. Works for "M / Breastfeeding", "M", "M / Black".
      function findTopVariant(product, size, wantBF) {
          let match = null;
          product.variants.forEach(function (variant) {
              if (match) return;
              let parts = variant.title.toUpperCase().split('/').map(function (p) { return p.trim(); });
              if (parts[0] !== size) return;
              let typePart = parts.find(function (p) { return p.indexOf('BREASTFEEDING') !== -1; });
              if (typePart) {
                  let isNonBF = typePart.indexOf('NON') !== -1;
                  if (isNonBF === wantBF) return;
              }
              match = variant;
          });
          return match;
      }

      function getTopRecommendations(answers, allProducts) {
          let cupIndex = ['A', 'B', 'C'].includes(answers.cup) ? 0 : 1;
          let row = SIZE_BY_BUST[parseInt(answers.bust)];
          if (!row) return [];
          let trueSize = row[cupIndex];
          let wantBF = answers.stage !== 'Neither';
          let recs = [];

          TOP_STYLES.forEach(function (style) {
              let size = shiftTopSize(trueSize, style.shift);
              let inStock = [];
              let fallback = null;
              style.handles.forEach(function (h) {
                  if (inStock.length >= style.show) return;
                  if (h.only === 'bf' && !wantBF) return;
                  if (h.only === 'nonbf' && wantBF) return;
                  let product = allProducts[h.handle];
                  if (!product || product.online === false) return;
                  let variant = findTopVariant(product, size, wantBF);
                  if (!variant) return;
                  let rec = { product: product, variant: variant, size: size, trueSize: trueSize, note: style.note, shift: style.shift };
                  if (variant.available) inStock.push(rec);
                  else if (!fallback) fallback = rec;
              });
              if (inStock.length) recs = recs.concat(inStock);
              else if (fallback) recs.push(fallback);
          });
          return recs;
      }

      let klavyoItems = [];
      function loadProducts(answers) {
          allProductsLoader(function (allProducts) {
              // the loader can call back twice (cache then fresh), so start clean each time
              klavyoItems = [];
              $('#product-results').empty();
              $('.size-quiz-tops .no-results').remove();

              let recs = getTopRecommendations(answers, allProducts);
              if (!recs.length) {
                  $('#product-results').after(
                      '<div class="no-results text-center my-5">' +
                      '<p>We don\'t have a top in stock in your size right now.</p>' +
                      '<p>Check the <a href="/pages/size-guide">size chart</a> or flick us a message and we\'ll help you find your fit.</p>' +
                      '</div>'
                  );
                  return;
              }
              recs.forEach(function (rec) {
                  displayLoadedProduct(rec, allProducts);
              });
          });
      }

      // The store's money format has no cents ("$0 NZD"), so swap the number in
      // rather than looking for "0.00". Shows cents only when the price has them.
      function formatPrice(cents) {
          let amount = Number(cents) / 100;
          let shown = (amount % 1 === 0) ? String(amount) : amount.toFixed(2);
          let fmt = $('.size-quiz-tops').attr('data-price-format') || '$0';
          return fmt.replace(/\d+(?:[.,]\d+)?/, shown);
      }

      function displayLoadedProduct(rec, allProducts) {
          let product = $.extend(true, {}, rec.product);
          let size = rec.size;
          let variantId = rec.variant.id;
          let available = rec.variant.available;

          let klavyoProduct = $.extend(true, {}, product);
          klavyoProduct.selectedSize = size;
          klavyoProduct.selectedVariant = variantId;
          klavyoProduct.selectedVariantAvailable = available;
          klavyoProduct.description = '';
          klavyoItems.push(klavyoProduct);

          let imagesHtml = '';
          let mainImg = '';
          let mainAlt = '';
          if (product.images && product.images.length) {
              let sizeWidths = Object.keys(product.images[0].sizes).reverse();
              let sizes = Object.values(product.images[0].sizes).reverse();
              $.each(sizes, function (key, imgsize) {
                  if (key >= sizes.length - 2) {
                      return;
                  }
                  imagesHtml += '<source media="(min-width: ' + sizeWidths[key + 1] + 'px)" srcset="' + imgsize + '">';
              });
              mainImg = product.images[0].sizes[105];
              mainAlt = product.images[0].alt;
          }

          let price = formatPrice(rec.variant.price || product.price);
          // Colour swatches: only shown when there are 2+ colours live, and any swatch
          // whose image is missing from the theme hides itself instead of showing broken.
          let colourHtml = '';
          let colourCount = 0;
          $.each(product.colour_group || [], function (key, handle) {
              if (allProducts.hasOwnProperty(handle) && allProducts[handle].online && allProducts[handle].swatch) {
                  colourCount++;
                  colourHtml += '<a href="/products/' + handle + '" data-handle="' + handle + '" class="colour-picker rounded-circle mr-2 ' + (handle == product.handle ? 'border' : '') + '">' +
                      '<img class="rounded-circle alt-colour" src="' + allProducts[handle].swatch + '" alt="" onerror="this.parentNode.style.display=\'none\'">' +
                      '</a>';
              }
          });
          if (colourCount < 2) colourHtml = '';

          let displayTitle = product.colour ? product.title.replace(product.colour, '') : product.title;
          let sizeNote = '';
          if (rec.note) {
              sizeNote = '<span class="size-note d-block mb-2">' + rec.note +
                  (rec.shift < 0 && rec.size !== rec.trueSize ? ' to ' + size : '') + '</span>';
          }

          let template = '<div class="col col-9 col-md-4 product-col">' +
              '<div class="container grid-item pb-0">' +
                '<div class="main-image-frame position-relative">' +
                  '<a href="/products/' + product.handle + '?variant=' + variantId + '">' +
                    '<picture class="main-image">' +
                      imagesHtml +
                      '<img class="img-fluid" src="' + mainImg + '" alt="' + mainAlt + '">' +
                    '</picture>' +
                    '<span class="d-none plus-symbol" data-handle="' + product.handle + '" data-varaint-id="' + variantId + '" data-toggle="modal" data-target="#other-product-modal">+</span>' +
                  '</a>' +
                '</div>' +
                '<div class="row details">' +
                  '<div class="col py-2 text-center">' +
                    '<span class="no-wrap d-block"><a href="/products/' + product.handle + '?variant=' + variantId + '">' +
                      displayTitle + '</a></span>' +
                    '<span class="price mb-2">' + price + '</span>' +
                    sizeNote +
                    '<div class="colour-pickers" data-handle="' + product.handle + '">' +
                      colourHtml +
                    '</div>' +
                    (available ?
                      '<a href="/products/' + product.handle + '?variant=' + variantId + '" class="btn add-to-cart" data-handle="' + product.handle + '" data-variant-title="' + rec.variant.title + '" data-variant-id="' + variantId + '" data-product-title="' + product.title + '" data-image-url="' + mainImg + '" data-price="' + price + '">' +
                        'Size ' + size + ' - Add to cart</a>'
                      : '<a href="/products/' + product.handle + '?variant=' + variantId + '" class="d-block">Size ' + size + ' - Out of stock, get notified</a>') +
                  '</div>' +
                '</div>' +
              '</div>' +
            '</div>';

          $('#product-results').append(template);
          addQuickViewEvent();
      }


    function addQuickViewEvent() {
      $('#quiz-slider-tops').find('.quick-view-button').click(function(e) {
        e.preventDefault();
      });

      $('.size-quiz-tops .main-image-frame').off('hover');
      $('.size-quiz-tops .main-image-frame').hover(function(){
        $(this).find('.quick-view-button').addClass('hovered');
      },function(){
        $(this).find('.quick-view-button').removeClass('hovered');
      });

      $('.size-quiz-tops .plus-symbol').off('click');
      $('.size-quiz-tops .plus-symbol').click(function(e){e.preventDefault();});

      $('.size-quiz-tops .add-to-cart').off('click');
      $('.size-quiz-tops .add-to-cart').click(function(){
        if (typeof addToSideCart === 'function') {
          addToSideCart($(this).attr('data-variant-id'),$(this).attr('data-price'),$(this).attr('data-image-url'),$(this).attr('data-product-title'),$(this).attr('data-variant-title'),$(this).attr('data-handle'));
          if (typeof showSideCart === 'function') showSideCart();
        }
      });
    }

      // Highlight picked options and show what she's chosen so far
      function refreshSelected() {
          let stageInputs = document.querySelectorAll('.size-quiz-tops input[name="stage"]');
          let anyStage = false;
          stageInputs.forEach(function (input) {
              let label = input.closest('label');
              if (!label) return;
              label.classList.toggle('is-selected', input.checked);
              if (input.checked) anyStage = true;
          });
          let stageSlide = document.querySelector('.size-quiz-tops .pregnancy-stage');
          if (stageSlide) stageSlide.classList.toggle('has-selection', anyStage);

          let top = document.querySelector('.size-quiz-tops input[name="top_size"]:checked');
          let bust = document.querySelector('.size-quiz-tops input[name="bust_size"]:checked');
          let cup = document.querySelector('.size-quiz-tops input[name="cup_size"]:checked');
          let labelText = function (input) {
              let l = document.querySelector('.size-quiz-tops label[for="' + input.id + '"]');
              return l ? l.textContent.replace(/\s+/g, ' ').replace(/cm.*$/, 'cm').trim() : input.value;
          };
          let pickedSize = document.querySelector('.size-quiz-tops .picked-size');
          if (pickedSize) {
              let bits = [];
              if (top) bits.push('Size <strong>' + labelText(top) + '</strong>');
              if (bust) bits.push('bust <strong>' + labelText(bust) + '</strong>');
              pickedSize.innerHTML = bits.length ? 'You picked: ' + bits.join(', ') : '';
          }
          let pickedCup = document.querySelector('.size-quiz-tops .picked-cup');
          if (pickedCup) {
              pickedCup.innerHTML = cup ? 'Your cup: <strong>' + cup.value + '</strong>' : '';
          }
      }
      document.querySelectorAll('.size-quiz-tops input[type="radio"]').forEach(function (input) {
          input.addEventListener('change', refreshSelected);
          input.addEventListener('input', refreshSelected);
      });
      // the size, bust and cup pickers tick each other in code, so refresh after any tap
      document.querySelectorAll('.size-quiz-tops .size-clickable, .size-quiz-tops .bust-clickable, .size-quiz-tops .cup-clickable, .size-quiz-tops .next-btn, .size-quiz-tops .back-btn').forEach(function (el) {
          el.addEventListener('click', function () { setTimeout(refreshSelected, 50); });
      });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["size-quiz"]) return;
  try {
    
      $('.start-btn').on('click', function () {
          setTimeout(function () {
              $('.mobile-scroll').scrollLeft(60);
          }, 10);
      });


      $('#slide3-btn-2').on('click', function () {
          if (!$('input[name=band_fit]:checked').val()) {
              $('input[name=band_fit]').eq(1).prop("checked", true);
          }
          if (!$('input[name=cup_fit]:checked').val()) {
              $('input[name=cup_fit]').eq(1).prop("checked", true);
          }
          if (!$('input[name=stage]:checked').val()) {
              $('input[name=stage]').eq(1).prop("checked", true);
          }
          if (!$('input[name=support_level]:checked').val()) {
              $('input[name=support_level]').eq(1).prop("checked", true);
          }
      });


      let fit_sizes = ['Too loose, rides up my back.', 'Too loose, rides up my back.', 'Too tight, dips in and feels uncomfortable.', 'Perfect! It’s comfortable and fits well.', 'Perfect! It’s comfortable and fits well.'];
      addMobileSlider("jssor_1", fit_sizes, '.band-fit', 750, 'band_fit');

      let cup_fit_sizes = ['Perfect!', 'Perfect!', 'My breasts are squashed and overflow.', 'My Cup isn’t full, and gaps alot.', 'My Cup isn’t full, and gaps alot.'];
      addMobileSlider("jssor_2", cup_fit_sizes, '.cup-fit', 750, 'cup_fit');

      let stages = ['1st Trimester', '1st Trimester', '2nd Trimester', '3rd Trimester', 'Breastfeeding', 'Neither, just love Cadenshae!', 'Neither, just love Cadenshae!'];
      addMobileSlider("jssor_3", stages, '.pregnancy-stage', 550, 'stage');

      let support_level = ['Low', 'Low', 'Moderate', 'High', 'High'];
      addMobileSlider("jssor_4", support_level, '.support-level', 750, 'support_level');


      function addMobileSlider(elementId, selectionTexts, parentSelector, slideWidth, radioName) {
          window.jssor_1_slider_init = function () {

              var slider_options = {
                  $AutoPlay: 0,
                  $SlideWidth: slideWidth,
                  $Loop: 0,
                  $StartIndex: 2
              };

              var slider = new $JssorSlider$(elementId, slider_options);

              slider.$On($JssorSlider$.$EVT_PARK, function (slideIndex, fromIndex) {
                  var slideIndex2 = Math.round(slider.$CurrentPosition());
                  $(parentSelector).find('.slider-text').text(selectionTexts[slideIndex2]);

                  if (slideIndex2 == 0) {
                      slider.$PlayTo(1);
                  }
                  if (slideIndex2 == slider.$SlidesCount() - 1) {
                      slider.$PlayTo(slider.$SlidesCount() - 2);
                  }

                  $('input[name=' + radioName + ']').each(function (index) {
                      if (index + 1 == slideIndex2) {
                          $(this).prop("checked", true);
                      } else {
                          $(this).prop("checked", false);
                      }
                  });
                  refreshSelected();

              });

              /*#region responsive code begin*/

              var MAX_WIDTH = 980;

              function ScaleSlider() {
                  var containerElement = slider.$Elmt.parentNode;
                  var containerWidth = containerElement.clientWidth;

                  if (containerWidth) {
                      var expectedWidth = Math.min(MAX_WIDTH || containerWidth, containerWidth);
                      slider.$ScaleWidth(expectedWidth);
                  } else {
                      window.setTimeout(ScaleSlider, 30);
                  }
              }

              ScaleSlider();

              $Jssor$.$AddEvent(window, "load", ScaleSlider);
              $Jssor$.$AddEvent(window, "resize", ScaleSlider);
              $Jssor$.$AddEvent(window, "orientationchange", ScaleSlider);
              /*#endregion responsive code end*/
          };
          jssor_1_slider_init();
      }

      $(window).resize(function () {
          displayRadioBar();
      });


      function displayRadioBar() {
          setTimeout(function () {
              radioBarPositioning(".band-fit");
              radioBarPositioning(".cup-fit");
              radioBarPositioning(".pregnancy-stage");
              radioBarPositioning(".support-level");
          }, 1000);
      }

      function radioBarPositioning(selector) {
          let firstRadioPos = $(selector).find(".fit-first-radio").offset();
          let newLeft = firstRadioPos.left + 7;
          let lastRadioPos = $(selector).find(".fit-last-radio").offset();
          let newWidth = (lastRadioPos.left - newLeft) + 3;
          let newTop = firstRadioPos.top + 7;
          $(selector).find(".fit-bar").css({top: newTop, left: newLeft, width: newWidth});
      }


      $('.carousel').carousel('pause');

      // Highlight picked options and show the size she's chosen so far
      function refreshSelected() {
          ['band_fit', 'cup_fit', 'stage', 'support_level'].forEach(function (name) {
              let inputs = document.querySelectorAll('input[name="' + name + '"]');
              let anyChecked = false;
              inputs.forEach(function (input) {
                  let label = input.closest('label');
                  if (!label) return;
                  label.classList.toggle('is-selected', input.checked);
                  if (input.checked) anyChecked = true;
              });
              if (inputs.length) {
                  let slide = inputs[0].closest('.carousel-item');
                  if (slide) slide.classList.toggle('has-selection', anyChecked);
              }
          });
          let band = document.querySelector('input[name="band_size"]:checked');
          let cup = document.querySelector('input[name="cup_size"]:checked');
          let picked = document.querySelector('.size-quiz .picked-size');
          if (picked) {
              if (band || cup) {
                  let bandText = band ? document.querySelector('label[for="' + band.id + '"]').textContent.trim() : '?';
                  picked.innerHTML = (band && cup)
                      ? 'Your current bra: <strong>' + bandText + cup.value + '</strong>'
                      : (band ? 'Band <strong>' + bandText + '</strong>, now pick your cup' : 'Cup <strong>' + cup.value + '</strong>, now pick your band');
              } else {
                  picked.innerHTML = '';
              }
          }
      }
      document.querySelectorAll('.size-quiz input[type="radio"]').forEach(function (input) {
          input.addEventListener('change', refreshSelected);
          input.addEventListener('input', refreshSelected);
      });
      document.querySelectorAll('.size-quiz .next-btn, .size-quiz .back-btn').forEach(function (btn) {
          btn.addEventListener('click', function () { setTimeout(refreshSelected, 50); });
      });

      $('input').on('input', function () {
          if ($('input[name=band_size]:checked').val() && $('input[name=cup_size]:checked').val()) {
              $('#slide2-btn').prop('disabled', false);
          }
          if ($('input[name=band_fit]:checked').val()) {
              $('#slide3-btn').prop('disabled', false);
          }
          if ($('input[name=cup_fit]:checked').val()) {
              $('#slide4-btn').prop('disabled', false);
          }
          if ($('input[name=stage]:checked').val()) {
              $('#slide5-btn').prop('disabled', false);
          }
          if ($('input[name=support_level]:checked').val()) {
              $('#slide6-btn').prop('disabled', false);
          }
          if ($('#email').is(':valid')) {
              $('#slide8-btn').prop('disabled', false);
          }
      });

      $('.back-btn').on('click', function () {
          $('.carousel').carousel('prev');
          displayRadioBar();
      });

      $('.next-btn').on('click', function () {
          $('.carousel').carousel('next');
          displayRadioBar();
      });

      function getAnswers() {
          let stages = ['1st Trimester', '2nd Trimester', '3rd Trimester', 'Breastfeeding', 'Neither'];
          let supportLevels = ['Low', 'Moderate', 'High'];

          return {
              'bottom': $('input[name=bottom_size]:checked').val(),
              'band': getBandSize(),
              'cup': getCupSize(),
              'email': $('#email').val(),
              'stage': stages[$('input[name=stage]:checked').val()],
              'support': supportLevels[$('input[name=support_level]:checked').val() - 1]
          };
      }

      $('#slide8-btn').on('click', function () {
          let answers = getAnswers();
          updateUrl(answers);
  		fbq('track', 'Lead');

          _learnq.push(['identify', {
              '$email': answers.email,
              'Pregnancy Stage': answers.stage,
              'Support Level': answers.support,
              'Bottom Size': answers.bottom,
              'Band Size': answers.band,
              'Cup Size': answers.cup
          }]);

  	  	_learnq.push(['track', 'Bra Quiz', {
              'items': klavyoItems
          }]);
      });

      $('#not-now-btn').on('click', function () {
          updateUrl(getAnswers());
      });



      $('#restart-quiz').click(function(e) {
  		e.preventDefault();
  		localStorage.removeItem("quiz-results");
  		window.location = '/pages/size-quiz';
  	});

      function updateUrl(answers) {
          let queryString = $.param(answers);
          window.history.pushState(" ", "Quiz Results", "?" + queryString);
  		localStorage.setItem("quiz-results", queryString);
      }


      function getBandSize() {
          let band = parseInt($('input[name=band_size]:checked').val());
          let band_fit = $('input[name=band_fit]:checked').val();
          if (band_fit == 'loose' && band != 8) {
              band = band - 2;
          } else if (band_fit == 'tight' && band != 20) {
              band = band + 2;
          }
          return band;
      }

      function getCupSize() {
          let cup = $('input[name=cup_size]:checked').val();
          let cup_fit = $('input[name=cup_fit]:checked').val();
          let cupSizeNumber = cupSizes.indexOf(cup);
          if (cup_fit == 'tight' && cup != 'A') {
              cupSizeNumber = cupSizeNumber + 1;
          } else if (cup_fit == 'loose' && cup != 'J') {
              cupSizeNumber = cupSizeNumber - 1;
          }

          return cupSizes[cupSizeNumber];
      }

      $(document).ready(function() {
          let queryVars = getUrlVars();
          if (queryVars.band && queryVars.cup) {
              loadProducts(queryVars);
              $('.carousel').carousel(8);
          }
      });

      function getUrlVars() {
          var vars = [], hash;
          var hashes = [];
  		if (window.location.href.indexOf('?') > 0) {
  			hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
  		} else if (localStorage.getItem("quiz-results")) {
  			hashes = localStorage.getItem("quiz-results").split('&');
  		}
  		for(var i = 0; i < hashes.length; i++)
          {
              hash = hashes[i].split('=');
              vars.push(hash[0]);
              vars[hash[0]] = decodeURIComponent((hash[1] || '').replace(/\+/g, ' '));
          }

          return vars;
      }

      $('#slide6-btn').on('click', function () {
          loadProducts(getAnswers());
      });

      $('#slide6-btn-2').on('click', function () {
          loadProducts(getAnswers());
      });

      let cupSizes = ['A', 'B', 'C', 'D', 'DD', 'E', 'F', 'FF', 'G', 'GG', 'H', 'HH', 'I', 'J'];

      /* ==========================================================================
         BRA RECOMMENDATION RULES  (updated Oct 2026)
         --------------------------------------------------------------------------
         Each style lists:
           handles  : product handles to try, in order. The quiz shows the FIRST one
                      that has the recommended size in stock. If none are in stock it
                      shows the first handle as "out of stock". Add new colourways here.
           nonBF    : true = non-breastfeeding bra, only shown to "Neither" customers
           cups     : cup sizes this bra suits
           support  : function(cup) -> 'High' | 'Moderate' | 'Low'
           size     : function(band, cup) -> the size label to match against the
                      variant title (e.g. 'M', '2XL', '14'). Return null to skip.
         ========================================================================== */

      // Band (NZ dress size) -> letter size. Freedom / Everyday / Evolve.
      const LETTER_BY_BAND = { 8: 'XS', 10: 'S', 12: 'M', 14: 'L', 16: 'XL', 18: '2XL', 20: '3XL' };
      const LETTER_ORDER = ['XXS', 'XS', 'S', 'M', 'L', 'XL', '2XL', '3XL'];
      function shiftLetter(letter, steps) {
          let i = LETTER_ORDER.indexOf(letter) + steps;
          i = Math.max(0, Math.min(LETTER_ORDER.length - 1, i));
          return LETTER_ORDER[i];
      }
      function cupsBetween(from, to) {
          return cupSizes.slice(cupSizes.indexOf(from), cupSizes.indexOf(to) + 1);
      }

      // Ultimate Bra: numbered sizes 8-20. Taken from the Ultimate size chart.
      const ULTIMATE_SIZES = {
          8:  { E: 8,  F: 8,  FF: 8,  G: 8,  GG: 10 },
          10: { D: 8,  DD: 8,  E: 10, F: 10, FF: 12, G: 12, GG: 12 },
          12: { D: 10, DD: 10, E: 12, F: 12, FF: 14, G: 14, GG: 14 },
          14: { D: 12, DD: 12, E: 14, F: 14, FF: 14, G: 16, GG: 16 },
          16: { D: 14, DD: 14, E: 16, F: 16, FF: 16, G: 16, GG: 18 },
          18: { D: 16, DD: 16, E: 18, F: 18, FF: 18, G: 20, GG: 20 },
          20: { D: 18, DD: 18, E: 18, F: 20, FF: 20, G: 20 }
      };
      function ultimateSize(band, cup) {
          let s = ULTIMATE_SIZES[band] && ULTIMATE_SIZES[band][cup];
          return s ? String(s) : null;
      }

      const BRA_STYLES = [
          {
              name: 'Ultimate Bra',
              handles: ['nursing-sports-bra-ultimate-bra-1', 'nursing-sports-bra-ultimate-high-impact-bra-black', 'nursing-sports-bra-ultimate-bra', 'nursing-sports-bra-ultimate-bra-duskypink'],
              cups: cupsBetween('D', 'GG'),
              support: function () { return 'High'; },
              size: ultimateSize
          },
          {
              name: 'Ultimate Bra (non-breastfeeding)',
              nonBF: true,
              handles: ['wireless-high-impact-sports-bra-ultimate-bra-black'],
              cups: cupsBetween('D', 'GG'),
              support: function () { return 'High'; },
              size: ultimateSize // variant titles are "XL / 16" so the number matches
          },
          {
              name: 'Freedom Bra',
              handles: ['breastfeeding-bra-freedom-bra-black', 'breastfeeding-bra-freedom-bra-sage', 'breastfeeding-bra-freedom-bra-cupid'],
              cups: cupsBetween('A', 'E'),
              support: function (cup) {
                  if (['A', 'B', 'C'].includes(cup)) return 'High';
                  if (['D', 'DD'].includes(cup)) return 'Moderate';
                  return 'Low';
              },
              size: function (band) { return LETTER_BY_BAND[band] || null; }
          },
          {
              name: 'Everyday Racerback Bra',
              handles: ['racerback-nursing-bra-everyday-black'],
              cups: cupsBetween('A', 'E'),
              support: function (cup) {
                  if (['A', 'B'].includes(cup)) return 'High';
                  if (['C', 'D'].includes(cup)) return 'Moderate';
                  return 'Low';
              },
              size: function (band) { return LETTER_BY_BAND[band] || null; }
          },
          {
              name: 'Evolve Crossover Bra',
              handles: ['crossover-nursing-sports-bra-evolve-bra-black', 'crossover-nursing-sports-bra-evolve-bra'],
              cups: cupsBetween('A', 'F'),
              support: function (cup) {
                  if (['A', 'B'].includes(cup)) return 'High';
                  if (cup === 'F') return 'Low';
                  return 'Moderate';
              },
              size: function (band, cup) {
                  let letter = LETTER_BY_BAND[band];
                  if (!letter) return null;
                  if (['A', 'B'].includes(cup) && band >= 12) return shiftLetter(letter, -1); // small cups size down
                  if (cup === 'F') return shiftLetter(letter, 1); // F cup sizes up
                  return letter;
              }
          },
          {
              name: 'Evolve Crossover Bra (non-breastfeeding)',
              nonBF: true,
              handles: ['crossover-sports-bra-evolve-bra'],
              cups: cupsBetween('A', 'F'),
              support: function (cup) {
                  if (['A', 'B'].includes(cup)) return 'High';
                  if (cup === 'F') return 'Low';
                  return 'Moderate';
              },
              size: function (band, cup) {
                  let letter = LETTER_BY_BAND[band];
                  if (!letter) return null;
                  if (['A', 'B'].includes(cup) && band >= 12) return shiftLetter(letter, -1);
                  if (cup === 'F') return shiftLetter(letter, 1);
                  return letter;
              }
          },
          {
              name: 'Hush Sleep Bra',
              handles: ['sleep-bra-hush-seamless-bamboo-bra-black', 'sleep-bra-hush-seamless-bamboo-bra-sienna'],
              cups: cupsBetween('A', 'E'),
              support: function () { return 'Low'; },
              size: function (band) {
                  if (band <= 10) return 'S';
                  if (band === 12) return 'M';
                  if (band === 14) return 'L';
                  return 'XL';
              }
          },
          {
              name: 'Luxe Bra (H-J cup)',
              handles: ['plus-size-nursing-bra-luxe-bra-black'],
              cups: ['FF', 'G', 'GG', 'H', 'HH', 'I', 'J'],
              support: function () { return 'High'; },
              size: function (band, cup) {
                  if (band >= 16) {
                      if (band === 16 && ['G', 'GG'].includes(cup)) return 'L';
                      if (cup === 'FF' && band < 18) return null; // FF under 18 goes to Ultimate
                      return 'XL';
                  }
                  if (cup === 'FF') return null;
                  let letter = LETTER_BY_BAND[band];
                  if (['G', 'GG'].includes(cup)) {
                      if (band === 8) return null; // 8G / 8GG are covered by Ultimate
                      return shiftLetter(letter, -1);
                  }
                  return letter;
              }
          }
      ];

      // Finds the variant whose title starts with (or contains as a "/"-separated part)
      // the size label. Works for "M / 12", "2XL / 18-20", "16 / Breastfeeding", "XL", "14".
      function findVariant(product, sizeLabel) {
          let label = String(sizeLabel).toUpperCase().trim();
          let match = null;
          product.variants.forEach(function (variant) {
              if (match) return;
              let parts = variant.title.toUpperCase().split('/').map(function (p) { return p.trim(); });
              let hit = parts.some(function (p) {
                  return p === label || p.split('-')[0].trim() === label;
              });
              if (hit) match = variant;
          });
          return match;
      }

      function getRecommendations(answers, allProducts) {
          let band = parseInt(answers.band);
          let cup = answers.cup;
          let showNonBF = answers.stage === 'Neither';
          let recs = [];

          BRA_STYLES.forEach(function (style) {
              if (style.nonBF && !showNonBF) return;
              if (!style.cups.includes(cup)) return;
              let sizeLabel = style.size(band, cup);
              if (!sizeLabel) return;

              let fallback = null;
              let chosen = null;
              style.handles.forEach(function (handle) {
                  if (chosen) return;
                  let product = allProducts[handle];
                  if (!product || product.online === false) return;
                  let variant = findVariant(product, sizeLabel);
                  if (!variant) return;
                  if (variant.available) {
                      chosen = { product: product, variant: variant };
                  } else if (!fallback) {
                      fallback = { product: product, variant: variant };
                  }
              });

              let pick = chosen || fallback;
              if (pick) {
                  recs.push({
                      product: pick.product,
                      variant: pick.variant,
                      size: sizeLabel,
                      level: style.support(cup),
                      band: band
                  });
              }
          });
          return recs;
      }

      let klavyoItems = [];
      function loadProducts(answers) {
          klavyoItems = [];
          $('.results').empty();

          let displayLevels = [];
          if (answers.support == 'Low') {
              displayLevels = ['Low', 'Moderate', 'High'];
          } else if (answers.support == 'High') {
              displayLevels = ['High', 'Moderate', 'Low'];
          } else {
              displayLevels = ['Moderate', 'High', 'Low'];
          }
          addSupportLevels(displayLevels);

          allProductsLoader(function (allProducts) {
              // the loader can call back twice (cache then fresh), so clear first
              klavyoItems = [];
              displayLevels.forEach(function (level) {
                  $('#product-results-' + level).empty();
                  $('#results-title-' + level).hide();
              });
              $('.results .no-results').remove();

              let recs = getRecommendations(answers, allProducts);

              if (!recs.length) {
                  $('.results').append(
                      '<div class="no-results text-center my-5">' +
                      '<p>We don\'t have a bra in stock for that exact size right now.</p>' +
                      '<p>Check the <a href="/pages/size-guide">size chart</a> or flick us a message and we\'ll help you find your fit.</p>' +
                      '</div>'
                  );
                  return;
              }

              recs.forEach(function (rec) {
                  displayLoadedProduct(rec, allProducts);
              });
          });
      }

      function addSupportLevels(levels) {
          levels.forEach(function (item, index) {
              let template = '<h3 class="my-4" style="display:none;" id="results-title-' + item + '">' + item + ' Support</h3>' +
                  '<div class="row row-cols-md-3 no-gutters product-row" id="product-results-' + item + '"></div>';
              $('.results').append(template);
          });
      }


      // The store's money format has no cents ("$0 NZD"), so swap the number in
      // rather than looking for "0.00". Shows cents only when the price has them.
      function formatPrice(cents) {
          let amount = Number(cents) / 100;
          let shown = (amount % 1 === 0) ? String(amount) : amount.toFixed(2);
          let fmt = $('.size-quiz').attr('data-price-format') || '$0';
          return fmt.replace(/\d+(?:[.,]\d+)?/, shown);
      }

      function displayLoadedProduct(rec, allProducts) {
          let level = rec.level;
          let size = rec.size;
          $('#results-title-' + level).show();

          let product = $.extend(true, {}, rec.product);
          let variantId = rec.variant.id;
          let available = rec.variant.available;

          let klavyoProduct = $.extend(true, {}, product);
          klavyoProduct.selectedSize = size;
          klavyoProduct.selectedVariant = variantId;
          klavyoProduct.selectedVariantAvailable = available;
          klavyoProduct.description = '';
          klavyoItems.push(klavyoProduct);

          let imagesHtml = '';
          let mainImg = '';
          let mainAlt = '';
          if (product.images && product.images.length) {
              let sizeWidths = Object.keys(product.images[0].sizes).reverse();
              let sizes = Object.values(product.images[0].sizes).reverse();
              $.each(sizes, function (key, imgsize) {
                  if (key >= sizes.length - 2) {
                      return;
                  }
                  imagesHtml += '<source media="(min-width: ' + sizeWidths[key + 1] + 'px)" srcset="' + imgsize + '">';
              });
              mainImg = product.images[0].sizes[105];
              mainAlt = product.images[0].alt;
          }

          let price = formatPrice(rec.variant.price || product.price);
          let colourHtml = '';
          $.each(product.colour_group || [], function (key, handle) {
              if (allProducts.hasOwnProperty(handle) && allProducts[handle].online) {
                  colourHtml += '<a href="/products/' + handle + '" data-handle="' + handle + '" class="colour-picker rounded-circle mr-2 ' + (handle == product.handle ? 'border' : '') + '">' +
                      '<img class="rounded-circle alt-colour" src="' + allProducts[handle].swatch + '" alt="Alternate Colours">' +
                      '</a>';
              }
          });

          let displayTitle = product.colour ? product.title.replace(product.colour, '') : product.title;
          let sizeText = 'Size ' + size;
          // Numbered bras (Ultimate) can differ from her usual band, so tell her why
          let sizeNote = '';
          if (/^\d+$/.test(String(size)) && rec.band && parseInt(size) !== rec.band) {
              sizeNote = '<span class="size-note d-block mb-2">' +
                  (parseInt(size) < rec.band ? 'Size down to ' : 'Size up to ') + size +
                  ' in this one for your cup</span>';
          }

          let template = '<div class="col col-9 col-md-4 product-col">' +
              '<div class="container grid-item pb-0">' +
                '<div class="main-image-frame position-relative">' +
                  '<a href="/products/' + product.handle + '?variant=' + variantId + '">' +
                    '<picture class="main-image">' +
                      imagesHtml +
                      '<img class="img-fluid" src="' + mainImg + '" alt="' + mainAlt + '">' +
                    '</picture>' +
                    '<span class="d-none plus-symbol" data-handle="' + product.handle + '" data-varaint-id="' + variantId + '" data-toggle="modal" data-target="#other-product-modal">+</span>' +
                  '</a>' +
                '</div>' +
                '<div class="row details">' +
                  '<div class="col py-2 text-center">' +
                    '<span class="no-wrap d-block"><a href="/products/' + product.handle + '?variant=' + variantId + '">' +
                      displayTitle + '</a></span>' +
                    '<span class="price mb-2">' + price + '</span>' +
                    sizeNote +
                    '<div class="colour-pickers" data-handle="' + product.handle + '">' +
                      colourHtml +
                    '</div>' +
                    (available ?
                      '<a href="/products/' + product.handle + '?variant=' + variantId + '" class="btn add-to-cart" data-handle="' + product.handle + '" data-variant-title="' + size + '" data-variant-id="' + variantId + '" data-product-title="' + product.title + '" data-image-url="' + mainImg + '" data-price="' + price + '">' +
                        sizeText + ' - Add to cart</a>'
                      : '<a href="/products/' + product.handle + '?variant=' + variantId + '" class="d-block">' + sizeText + ' - Out of stock, get notified</a>') +
                  '</div>' +
                '</div>' +
              '</div>' +
            '</div>';

          $('#product-results-' + level).append(template);
          addQuickViewEvent();
      }

    function addQuickViewEvent() {
      $('#quiz-slider').find('.quick-view-button').click(function(e) {
        e.preventDefault();
      });

      $('.main-image-frame').off('hover');
      $('.main-image-frame').hover(function(){
        $(this).find('.quick-view-button').addClass('hovered');
      },function(){
        $(this).find('.quick-view-button').removeClass('hovered');
      });

      $('#quiz-slider .plus-symbol').off('click');
      $('#quiz-slider .plus-symbol').click(function(e){e.preventDefault();});

      $('#quiz-slider .add-to-cart').off('click');
      $('#quiz-slider .add-to-cart').click(function(){
        if (typeof addToSideCart === 'function') {
          addToSideCart($(this).attr('data-variant-id'),$(this).attr('data-price'),$(this).attr('data-image-url'),$(this).attr('data-product-title'),$(this).attr('data-variant-title'),$(this).attr('data-handle'));
          if (typeof showSideCart === 'function') showSideCart();
        }
      });
    }

  } catch(e) { console.error(e); }
})();
})();
